// // // pages/LiveClassPage.jsx
// // import React, { useState, useEffect, useRef } from "react";
// // import { Link, useParams } from "react-router-dom";
// // import { motion } from "framer-motion";

// // const LiveClassPage = () => {
// //   const { classId } = useParams();
// //   const [isLoading, setIsLoading] = useState(true);
// //   const [classData, setClassData] = useState(null);
// //   const [activeTab, setActiveTab] = useState("video");
// //   const [chatMessages, setChatMessages] = useState([]);
// //   const [questionMessages, setQuestionMessages] = useState([]);
// //   const [newMessage, setNewMessage] = useState("");
// //   const [newQuestion, setNewQuestion] = useState("");
// //   const [isMicMuted, setIsMicMuted] = useState(true);
// //   const [isCameraOff, setIsCameraOff] = useState(true);
// //   const [isScreenSharing, setIsScreenSharing] = useState(false);
// //   const [isHandRaised, setIsHandRaised] = useState(false);
// //   const [isFullScreen, setIsFullScreen] = useState(false);
// //   const [isRecording, setIsRecording] = useState(false);
// //   const [participants, setParticipants] = useState([]);
// //   const [isResourcesPanelOpen, setIsResourcesPanelOpen] = useState(false);
// //   const [showNotes, setShowNotes] = useState(false);

// //   const videoContainerRef = useRef(null);
// //   const chatContainerRef = useRef(null);
// //   const questionContainerRef = useRef(null);

// //   // Simulated sample data (in a real app, this would come from an API)
// //   useEffect(() => {
// //     // Simulate API call to fetch class data
// //     setTimeout(() => {
// //       setClassData({
// //         id: classId || "12345",
// //         title: "Constitutional Law and Polity for NPSC",
// //         instructor: "Dr. Imtisunep Ao",
// //         instructorRole: "Constitutional Expert",
// //         status: "live", // live, scheduled, ended
// //         startTime: "10:00 AM",
// //         duration: "2 hours",
// //         participants: 86,
// //         description:
// //           "This session focuses on key constitutional topics relevant to the NPSC examination, including fundamental rights, directive principles, and constitutional amendments.",
// //       });

// //       setParticipants([
// //         {
// //           id: 1,
// //           name: "Dr. Imtisunep Ao",
// //           role: "Instructor",
// //           isHost: true,
// //           avatar: "/images/faculty/instructor-1.jpg",
// //         },
// //         {
// //           id: 2,
// //           name: "You",
// //           role: "Student",
// //           isYou: true,
// //           avatar: "/images/avatars/default-avatar.jpg",
// //         },
// //         {
// //           id: 3,
// //           name: "Kevichulie Liegise",
// //           role: "Student",
// //           avatar: "/images/students/student-1.jpg",
// //         },
// //         {
// //           id: 4,
// //           name: "Atsungla Aier",
// //           role: "Student",
// //           avatar: "/images/students/student-2.jpg",
// //         },
// //         {
// //           id: 5,
// //           name: "Vikali Zhimomi",
// //           role: "Teaching Assistant",
// //           avatar: "/images/faculty/ta-1.jpg",
// //         },
// //         {
// //           id: 6,
// //           name: "Thejangulie Zao",
// //           role: "Student",
// //           avatar: "/images/students/student-3.jpg",
// //         },
// //         {
// //           id: 7,
// //           name: "Keneilelie Kire",
// //           role: "Student",
// //           avatar: "/images/students/student-4.jpg",
// //         },
// //         {
// //           id: 8,
// //           name: "Neikehielie Rio",
// //           role: "Student",
// //           avatar: "/images/students/student-5.jpg",
// //         },
// //       ]);

// //       // Mock chat messages
// //       setChatMessages([
// //         {
// //           id: 1,
// //           sender: "Dr. Imtisunep Ao",
// //           role: "Instructor",
// //           message:
// //             "Welcome everyone to our Constitutional Law session. We will be covering fundamental rights today.",
// //           time: "10:01 AM",
// //           avatar: "/images/faculty/instructor-1.jpg",
// //         },
// //         {
// //           id: 2,
// //           sender: "Vikali Zhimomi",
// //           role: "Teaching Assistant",
// //           message:
// //             "Please use the Q&A tab for content-related questions. Use the chat for general comments.",
// //           time: "10:02 AM",
// //           avatar: "/images/faculty/ta-1.jpg",
// //         },
// //         {
// //           id: 3,
// //           sender: "Kevichulie Liegise",
// //           role: "Student",
// //           message: "Good morning everyone! Looking forward to today's class.",
// //           time: "10:03 AM",
// //           avatar: "/images/students/student-1.jpg",
// //         },
// //         {
// //           id: 4,
// //           sender: "Atsungla Aier",
// //           role: "Student",
// //           message: "The slides from last class were really helpful. Thanks!",
// //           time: "10:04 AM",
// //           avatar: "/images/students/student-2.jpg",
// //         },
// //         {
// //           id: 5,
// //           sender: "Dr. Imtisunep Ao",
// //           role: "Instructor",
// //           message:
// //             "I've shared today's reading material in the resources section. Please download it.",
// //           time: "10:05 AM",
// //           avatar: "/images/faculty/instructor-1.jpg",
// //         },
// //       ]);

// //       // Mock questions
// //       setQuestionMessages([
// //         {
// //           id: 1,
// //           sender: "Thejangulie Zao",
// //           role: "Student",
// //           question:
// //             "Could you explain the difference between fundamental rights and directive principles?",
// //           time: "10:08 AM",
// //           upvotes: 5,
// //           isAnswered: true,
// //           answer:
// //             "Great question! Fundamental rights are justiciable and enforceable in courts, while directive principles are non-justiciable guidelines for governance.",
// //           avatar: "/images/students/student-3.jpg",
// //         },
// //         {
// //           id: 2,
// //           sender: "Keneilelie Kire",
// //           role: "Student",
// //           question:
// //             "Which constitutional amendment is considered the most significant and why?",
// //           time: "10:15 AM",
// //           upvotes: 3,
// //           isAnswered: false,
// //           avatar: "/images/students/student-4.jpg",
// //         },
// //         {
// //           id: 3,
// //           sender: "Neikehielie Rio",
// //           role: "Student",
// //           question:
// //             "How many times has the Indian Constitution been amended so far?",
// //           time: "10:18 AM",
// //           upvotes: 2,
// //           isAnswered: false,
// //           avatar: "/images/students/student-5.jpg",
// //         },
// //       ]);

// //       setIsLoading(false);
// //     }, 1500);
// //   }, [classId]);

// //   // Auto-scroll chat to bottom when new messages are added
// //   useEffect(() => {
// //     if (chatContainerRef.current) {
// //       chatContainerRef.current.scrollTop =
// //         chatContainerRef.current.scrollHeight;
// //     }
// //   }, [chatMessages]);

// //   // Auto-scroll question container when new questions are added
// //   useEffect(() => {
// //     if (questionContainerRef.current) {
// //       questionContainerRef.current.scrollTop =
// //         questionContainerRef.current.scrollHeight;
// //     }
// //   }, [questionMessages]);

// //   const handleSendMessage = (e) => {
// //     e.preventDefault();
// //     if (!newMessage.trim()) return;

// //     const newChatMessage = {
// //       id: chatMessages.length + 1,
// //       sender: "You",
// //       role: "Student",
// //       message: newMessage,
// //       time: new Date().toLocaleTimeString([], {
// //         hour: "2-digit",
// //         minute: "2-digit",
// //       }),
// //       isYou: true,
// //       avatar: "/images/avatars/default-avatar.jpg",
// //     };

// //     setChatMessages([...chatMessages, newChatMessage]);
// //     setNewMessage("");
// //   };

// //   const handleSendQuestion = (e) => {
// //     e.preventDefault();
// //     if (!newQuestion.trim()) return;

// //     const newQuestionMessage = {
// //       id: questionMessages.length + 1,
// //       sender: "You",
// //       role: "Student",
// //       question: newQuestion,
// //       time: new Date().toLocaleTimeString([], {
// //         hour: "2-digit",
// //         minute: "2-digit",
// //       }),
// //       upvotes: 0,
// //       isAnswered: false,
// //       isYou: true,
// //       avatar: "/images/avatars/default-avatar.jpg",
// //     };

// //     setQuestionMessages([...questionMessages, newQuestionMessage]);
// //     setNewQuestion("");
// //   };

// //   const toggleFullScreen = () => {
// //     if (!document.fullscreenElement) {
// //       videoContainerRef.current.requestFullscreen().catch((err) => {
// //         console.error(
// //           `Error attempting to enable full-screen mode: ${err.message}`
// //         );
// //       });
// //       setIsFullScreen(true);
// //     } else {
// //       document.exitFullscreen();
// //       setIsFullScreen(false);
// //     }
// //   };

// //   const upvoteQuestion = (questionId) => {
// //     setQuestionMessages(
// //       questionMessages.map((q) =>
// //         q.id === questionId ? { ...q, upvotes: q.upvotes + 1 } : q
// //       )
// //     );
// //   };

// //   // Sort questions by upvotes (highest first)
// //   const sortedQuestions = [...questionMessages].sort(
// //     (a, b) => b.upvotes - a.upvotes
// //   );

// //   // Resources list (study materials, slides, etc.)
// //   const resources = [
// //     {
// //       id: 1,
// //       name: "Lecture Slides: Constitutional Amendments",
// //       type: "PDF",
// //       size: "2.4 MB",
// //       link: "#",
// //     },
// //     {
// //       id: 2,
// //       name: "Essential Articles of the Constitution",
// //       type: "DOCX",
// //       size: "1.8 MB",
// //       link: "#",
// //     },
// //     {
// //       id: 3,
// //       name: "Supreme Court Case Studies (2021-23)",
// //       type: "PDF",
// //       size: "3.5 MB",
// //       link: "#",
// //     },
// //     {
// //       id: 4,
// //       name: "Practice Questions: Fundamental Rights",
// //       type: "PDF",
// //       size: "1.2 MB",
// //       link: "#",
// //     },
// //     {
// //       id: 5,
// //       name: "Pre-class Reading: Constitutional Framework",
// //       type: "PDF",
// //       size: "4.1 MB",
// //       link: "#",
// //     },
// //   ];

// //   // Poll data (for interactive learning)
// //   const pollData = {
// //     question:
// //       "Which Article of the Indian Constitution abolishes untouchability?",
// //     options: [
// //       { id: 1, text: "Article 15", votes: 12 },
// //       { id: 2, text: "Article 17", votes: 45 },
// //       { id: 3, text: "Article 21", votes: 18 },
// //       { id: 4, text: "Article 32", votes: 8 },
// //     ],
// //     totalVotes: 83,
// //     yourVote: 2, // Option ID the user voted for (null if not voted)
// //     correctAnswer: 2, // Option ID of the correct answer
// //     isResultsVisible: true,
// //   };

// //   const calculatePercentage = (votes) => {
// //     return Math.round((votes / pollData.totalVotes) * 100);
// //   };

// //   if (isLoading) {
// //     return (
// //       <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
// //         <div className="text-center">
// //           <div
// //             className="animate-spin inline-block w-12 h-12 border-4 border-current border-t-transparent text-indigo-600 rounded-full"
// //             role="status"
// //             aria-label="loading"
// //           >
// //             <span className="sr-only">Loading...</span>
// //           </div>
// //           <p className="mt-4 text-lg text-gray-600">
// //             Joining the live class...
// //           </p>
// //         </div>
// //       </div>
// //     );
// //   }

// //   if (!classData) {
// //     return (
// //       <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
// //         <div className="text-center max-w-md px-4">
// //           <svg
// //             className="mx-auto h-16 w-16 text-gray-400"
// //             fill="none"
// //             viewBox="0 0 24 24"
// //             stroke="currentColor"
// //           >
// //             <path
// //               strokeLinecap="round"
// //               strokeLinejoin="round"
// //               strokeWidth={2}
// //               d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
// //             />
// //           </svg>
// //           <h2 className="mt-4 text-xl font-bold text-gray-700">
// //             Class Not Found
// //           </h2>
// //           <p className="mt-2 text-gray-500">
// //             We couldn't find the live class you're looking for. It may have
// //             ended or been rescheduled.
// //           </p>
// //           <Link
// //             to="/classes"
// //             className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
// //           >
// //             Back to Classes
// //           </Link>
// //         </div>
// //       </div>
// //     );
// //   }

// //   return (
// //     <div className="min-h-screen pt-16 bg-gray-100 mt-10">
// //       {/* Main video and interaction area */}
// //       <div className="flex flex-col lg:flex-row h-[calc(100vh-64px)]">
// //         {/* Left side - Video and controls */}
// //         <div className="lg:w-3/4 flex flex-col h-full">
// //           {/* Class info bar */}
// //           <div className="bg-indigo-900 text-white px-4 py-3 flex items-center justify-between">
// //             <div className="flex items-center">
// //               <div className="flex-shrink-0 h-10 w-10 rounded-full bg-indigo-700 flex items-center justify-center font-bold text-xl">
// //                 {classData.title.charAt(0)}
// //               </div>
// //               <div className="ml-3">
// //                 <h1 className="text-lg font-semibold">{classData.title}</h1>
// //                 <div className="flex items-center text-xs text-indigo-200">
// //                   <span className="flex items-center">
// //                     <span className="mr-2">{classData.instructor}</span>
// //                     {classData.status === "live" && (
// //                       <>
// //                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-500 text-white ml-2">
// //                           <span className="animate-ping absolute h-2 w-2 rounded-full bg-red-400 opacity-75"></span>
// //                           <span className="relative">LIVE</span>
// //                         </span>
// //                       </>
// //                     )}
// //                   </span>
// //                 </div>
// //               </div>
// //             </div>
// //             <div className="flex items-center space-x-4">
// //               <button
// //                 onClick={() => setIsRecording(!isRecording)}
// //                 className={`rounded-full p-2 ${
// //                   isRecording
// //                     ? "bg-red-500 text-white"
// //                     : "bg-white/10 hover:bg-white/20"
// //                 }`}
// //                 title={isRecording ? "Stop Recording" : "Start Recording"}
// //               >
// //                 <svg
// //                   className="h-5 w-5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
// //                   />
// //                 </svg>
// //               </button>
// //               <button
// //                 className="text-white hover:text-indigo-100"
// //                 onClick={() => setIsResourcesPanelOpen(!isResourcesPanelOpen)}
// //                 title="Resources"
// //               >
// //                 <svg
// //                   className="h-5 w-5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
// //                   />
// //                 </svg>
// //               </button>
// //               <button
// //                 className="text-white hover:text-indigo-100"
// //                 onClick={() => setShowNotes(!showNotes)}
// //                 title="Notes"
// //               >
// //                 <svg
// //                   className="h-5 w-5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
// //                   />
// //                 </svg>
// //               </button>
// //               <div className="hidden md:flex items-center space-x-2 text-xs">
// //                 <svg
// //                   className="h-4 w-4"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
// //                   />
// //                 </svg>
// //                 <span>
// //                   {classData.startTime} ({classData.duration})
// //                 </span>
// //               </div>
// //               <div className="hidden md:flex items-center space-x-2 text-xs">
// //                 <svg
// //                   className="h-4 w-4"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
// //                   />
// //                 </svg>
// //                 <span>{classData.participants} participants</span>
// //               </div>
// //             </div>
// //           </div>

// //           {/* Main video area */}
// //           <div
// //             className="flex-grow relative overflow-hidden bg-gray-900"
// //             ref={videoContainerRef}
// //           >
// //             {/* Video content */}
// //             <div className="relative h-full">
// //               <img
// //                 src="/images/live-class/lecture-screenshare.jpg"
// //                 alt="Lecture presentation"
// //                 className="w-full h-full object-contain"
// //               />

// //               {/* Instructor video (small overlay) */}
// //               <div className="absolute bottom-4 right-4 w-56 h-32 rounded-lg overflow-hidden shadow-lg border-2 border-white bg-gray-800">
// //                 <img
// //                   src="/images/faculty/instructor-1.jpg"
// //                   alt="Instructor"
// //                   className="w-full h-full object-cover"
// //                 />
// //                 <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-2">
// //                   <div className="text-white text-xs font-medium">
// //                     Dr. Imtisunep Ao (Instructor)
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* Poll overlay (when active) */}
// //               {/* <div className="absolute top-4 right-4 w-72 bg-white rounded-lg shadow-lg overflow-hidden">
// //                 <div className="bg-indigo-600 text-white p-3">
// //                   <h3 className="font-medium">Poll Question</h3>
// //                 </div>
// //                 <div className="p-4">
// //                   <p className="text-sm font-medium text-gray-700 mb-3">
// //                     {pollData.question}
// //                   </p>
// //                   <div className="space-y-2">
// //                     {pollData.options.map((option) => (
// //                       <div key={option.id} className="relative">
// //                         <div
// //                           className={`text-sm p-2 rounded ${
// //                             pollData.correctAnswer === option.id
// //                               ? "bg-green-100 border border-green-300"
// //                               : pollData.yourVote === option.id
// //                               ? "bg-blue-100 border border-blue-300"
// //                               : "bg-gray-100"
// //                           }`}
// //                         >
// //                           <div className="flex justify-between">
// //                             <span>{option.text}</span>
// //                             {pollData.isResultsVisible && (
// //                               <span className="font-medium">
// //                                 {calculatePercentage(option.votes)}%
// //                               </span>
// //                             )}
// //                           </div>
// //                           {pollData.isResultsVisible && (
// //                             <div className="mt-1 h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
// //                               <div
// //                                 className={`h-full ${
// //                                   pollData.correctAnswer === option.id
// //                                     ? "bg-green-500"
// //                                     : "bg-blue-500"
// //                                 }`}
// //                                 style={{
// //                                   width: `${calculatePercentage(
// //                                     option.votes
// //                                   )}%`,
// //                                 }}
// //                               ></div>
// //                             </div>
// //                           )}
// //                         </div>
// //                         {pollData.isResultsVisible &&
// //                           pollData.correctAnswer === option.id && (
// //                             <svg
// //                               className="absolute right-2 top-2 h-5 w-5 text-green-600"
// //                               fill="none"
// //                               viewBox="0 0 24 24"
// //                               stroke="currentColor"
// //                             >
// //                               <path
// //                                 strokeLinecap="round"
// //                                 strokeLinejoin="round"
// //                                 strokeWidth={2}
// //                                 d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
// //                               />
// //                             </svg>
// //                           )}
// //                       </div>
// //                     ))}
// //                   </div>
// //                   {!pollData.yourVote && !pollData.isResultsVisible && (
// //                     <button className="mt-3 w-full bg-indigo-600 text-white py-2 px-4 rounded text-sm font-medium hover:bg-indigo-700">
// //                       Submit Answer
// //                     </button>
// //                   )}
// //                   <div className="mt-3 text-xs text-gray-500 text-center">
// //                     {pollData.isResultsVisible ? (
// //                       <span>{pollData.totalVotes} votes • Poll closed</span>
// //                     ) : (
// //                       <span>Poll active • 30 seconds remaining</span>
// //                     )}
// //                   </div>
// //                 </div>
// //               </div> */}

// //               {/* Notes overlay (when active) */}
// //               {showNotes && (
// //                 <div className="absolute inset-0 bg-black/50 flex items-center justify-center p-6">
// //                   <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-full overflow-auto">
// //                     <div className="flex justify-between items-center p-4 border-b">
// //                       <h3 className="font-semibold text-lg">Class Notes</h3>
// //                       <button
// //                         onClick={() => setShowNotes(false)}
// //                         className="text-gray-500 hover:text-gray-700"
// //                       >
// //                         <svg
// //                           className="h-5 w-5"
// //                           fill="none"
// //                           viewBox="0 0 24 24"
// //                           stroke="currentColor"
// //                         >
// //                           <path
// //                             strokeLinecap="round"
// //                             strokeLinejoin="round"
// //                             strokeWidth={2}
// //                             d="M6 18L18 6M6 6l12 12"
// //                           />
// //                         </svg>
// //                       </button>
// //                     </div>
// //                     <div className="p-4">
// //                       <textarea
// //                         className="w-full h-64 p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
// //                         placeholder="Type your class notes here..."
// //                       ></textarea>
// //                       <div className="mt-4 flex justify-between">
// //                         <button className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800">
// //                           <svg
// //                             className="h-4 w-4 mr-1"
// //                             fill="none"
// //                             viewBox="0 0 24 24"
// //                             stroke="currentColor"
// //                           >
// //                             <path
// //                               strokeLinecap="round"
// //                               strokeLinejoin="round"
// //                               strokeWidth={2}
// //                               d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
// //                             />
// //                           </svg>
// //                           Save
// //                         </button>
// //                         <button className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800">
// //                           <svg
// //                             className="h-4 w-4 mr-1"
// //                             fill="none"
// //                             viewBox="0 0 24 24"
// //                             stroke="currentColor"
// //                           >
// //                             <path
// //                               strokeLinecap="round"
// //                               strokeLinejoin="round"
// //                               strokeWidth={2}
// //                               d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
// //                             />
// //                           </svg>
// //                           Download
// //                         </button>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               )}

// //               {/* Resources panel overlay */}
// //               {isResourcesPanelOpen && (
// //                 <div className="absolute inset-0 bg-black/50 flex items-center justify-center p-6">
// //                   <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-full overflow-auto">
// //                     <div className="flex justify-between items-center p-4 border-b">
// //                       <h3 className="font-semibold text-lg">Class Resources</h3>
// //                       <button
// //                         onClick={() => setIsResourcesPanelOpen(false)}
// //                         className="text-gray-500 hover:text-gray-700"
// //                       >
// //                         <svg
// //                           className="h-5 w-5"
// //                           fill="none"
// //                           viewBox="0 0 24 24"
// //                           stroke="currentColor"
// //                         >
// //                           <path
// //                             strokeLinecap="round"
// //                             strokeLinejoin="round"
// //                             strokeWidth={2}
// //                             d="M6 18L18 6M6 6l12 12"
// //                           />
// //                         </svg>
// //                       </button>
// //                     </div>
// //                     <div className="p-4">
// //                       <div className="space-y-3">
// //                         {resources.map((resource) => (
// //                           <div
// //                             key={resource.id}
// //                             className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
// //                           >
// //                             <div className="flex items-center">
// //                               <div className="flex-shrink-0">
// //                                 {resource.type === "PDF" ? (
// //                                   <div className="w-10 h-10 bg-red-100 text-red-600 rounded flex items-center justify-center">
// //                                     <svg
// //                                       className="h-6 w-6"
// //                                       fill="none"
// //                                       viewBox="0 0 24 24"
// //                                       stroke="currentColor"
// //                                     >
// //                                       <path
// //                                         strokeLinecap="round"
// //                                         strokeLinejoin="round"
// //                                         strokeWidth={2}
// //                                         d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
// //                                       />
// //                                     </svg>
// //                                   </div>
// //                                 ) : resource.type === "DOCX" ? (
// //                                   <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded flex items-center justify-center">
// //                                     <svg
// //                                       className="h-6 w-6"
// //                                       fill="none"
// //                                       viewBox="0 0 24 24"
// //                                       stroke="currentColor"
// //                                     >
// //                                       <path
// //                                         strokeLinecap="round"
// //                                         strokeLinejoin="round"
// //                                         strokeWidth={2}
// //                                         d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
// //                                       />
// //                                     </svg>
// //                                   </div>
// //                                 ) : (
// //                                   <div className="w-10 h-10 bg-gray-100 text-gray-600 rounded flex items-center justify-center">
// //                                     <svg
// //                                       className="h-6 w-6"
// //                                       fill="none"
// //                                       viewBox="0 0 24 24"
// //                                       stroke="currentColor"
// //                                     >
// //                                       <path
// //                                         strokeLinecap="round"
// //                                         strokeLinejoin="round"
// //                                         strokeWidth={2}
// //                                         d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
// //                                       />
// //                                     </svg>
// //                                   </div>
// //                                 )}
// //                               </div>
// //                               <div className="ml-3">
// //                                 <h4 className="text-sm font-medium text-gray-900">
// //                                   {resource.name}
// //                                 </h4>
// //                                 <p className="text-xs text-gray-500">
// //                                   {resource.type} • {resource.size}
// //                                 </p>
// //                               </div>
// //                             </div>
// //                             <a
// //                               href={resource.link}
// //                               className="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-800"
// //                               download
// //                             >
// //                               <svg
// //                                 className="h-5 w-5"
// //                                 fill="none"
// //                                 viewBox="0 0 24 24"
// //                                 stroke="currentColor"
// //                               >
// //                                 <path
// //                                   strokeLinecap="round"
// //                                   strokeLinejoin="round"
// //                                   strokeWidth={2}
// //                                   d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
// //                                 />
// //                               </svg>
// //                             </a>
// //                           </div>
// //                         ))}
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               )}
// //             </div>
// //           </div>

// //           {/* Video controls bar */}
// //           <div className="bg-indigo-800 p-3 text-white flex items-center justify-between">
// //             <div className="flex items-center space-x-4">
// //               <button
// //                 onClick={() => setIsMicMuted(!isMicMuted)}
// //                 className={`p-2 rounded-full ${
// //                   isMicMuted
// //                     ? "bg-red-500"
// //                     : "bg-indigo-600 hover:bg-indigo-700"
// //                 }`}
// //                 title={isMicMuted ? "Unmute Microphone" : "Mute Microphone"}
// //               >
// //                 {isMicMuted ? (
// //                   <svg
// //                     className="h-5 w-5"
// //                     fill="none"
// //                     viewBox="0 0 24 24"
// //                     stroke="currentColor"
// //                   >
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
// //                     />
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M3 3l18 18"
// //                     />
// //                   </svg>
// //                 ) : (
// //                   <svg
// //                     className="h-5 w-5"
// //                     fill="none"
// //                     viewBox="0 0 24 24"
// //                     stroke="currentColor"
// //                   >
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
// //                     />
// //                   </svg>
// //                 )}
// //               </button>

// //               <button
// //                 onClick={() => setIsCameraOff(!isCameraOff)}
// //                 className={`p-2 rounded-full ${
// //                   isCameraOff
// //                     ? "bg-red-500"
// //                     : "bg-indigo-600 hover:bg-indigo-700"
// //                 }`}
// //                 title={isCameraOff ? "Turn Camera On" : "Turn Camera Off"}
// //               >
// //                 {isCameraOff ? (
// //                   <svg
// //                     className="h-5 w-5"
// //                     fill="none"
// //                     viewBox="0 0 24 24"
// //                     stroke="currentColor"
// //                   >
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
// //                     />
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M3 3l18 18"
// //                     />
// //                   </svg>
// //                 ) : (
// //                   <svg
// //                     className="h-5 w-5"
// //                     fill="none"
// //                     viewBox="0 0 24 24"
// //                     stroke="currentColor"
// //                   >
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
// //                     />
// //                   </svg>
// //                 )}
// //               </button>

// //               <button
// //                 onClick={() => setIsScreenSharing(!isScreenSharing)}
// //                 className={`p-2 rounded-full ${
// //                   isScreenSharing
// //                     ? "bg-green-500"
// //                     : "bg-indigo-600 hover:bg-indigo-700"
// //                 }`}
// //                 title={isScreenSharing ? "Stop Sharing" : "Share Screen"}
// //               >
// //                 <svg
// //                   className="h-5 w-5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
// //                   />
// //                 </svg>
// //               </button>

// //               <button
// //                 onClick={() => setIsHandRaised(!isHandRaised)}
// //                 className={`p-2 rounded-full ${
// //                   isHandRaised
// //                     ? "bg-yellow-500"
// //                     : "bg-indigo-600 hover:bg-indigo-700"
// //                 }`}
// //                 title={isHandRaised ? "Lower Hand" : "Raise Hand"}
// //               >
// //                 <svg
// //                   className="h-5 w-5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
// //                   />
// //                 </svg>
// //               </button>
// //             </div>

// //             <div className="flex items-center space-x-4">
// //               <button
// //                 onClick={toggleFullScreen}
// //                 className="p-2 rounded-full bg-indigo-600 hover:bg-indigo-700"
// //                 title="Toggle Fullscreen"
// //               >
// //                 {isFullScreen ? (
// //                   <svg
// //                     className="h-5 w-5"
// //                     fill="none"
// //                     viewBox="0 0 24 24"
// //                     stroke="currentColor"
// //                   >
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M9 9V4.5M9 9H4.5M15 9H19.5M15 9V4.5M15 15v4.5M15 15H4.5M15 15h4.5M9 15v4.5"
// //                     />
// //                   </svg>
// //                 ) : (
// //                   <svg
// //                     className="h-5 w-5"
// //                     fill="none"
// //                     viewBox="0 0 24 24"
// //                     stroke="currentColor"
// //                   >
// //                     <path
// //                       strokeLinecap="round"
// //                       strokeLinejoin="round"
// //                       strokeWidth={2}
// //                       d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
// //                     />
// //                   </svg>
// //                 )}
// //               </button>

// //               <Link
// //                 to="/classes"
// //                 className="p-2 rounded-full bg-red-600 hover:bg-red-700"
// //                 title="Leave Class"
// //               >
// //                 <svg
// //                   className="h-5 w-5"
// //                   fill="none"
// //                   viewBox="0 0 24 24"
// //                   stroke="currentColor"
// //                 >
// //                   <path
// //                     strokeLinecap="round"
// //                     strokeLinejoin="round"
// //                     strokeWidth={2}
// //                     d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
// //                   />
// //                 </svg>
// //               </Link>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Right side - Chat, Q&A, participants */}
// //         <div className="lg:w-1/4 border-l border-gray-200 flex flex-col h-full bg-white">
// //           {/* Tabs for chat, Q&A, participants */}
// //           <div className="bg-gray-100 p-1">
// //             <div className="flex border-b border-gray-200">
// //               <button
// //                 className={`py-2 px-4 text-center text-sm font-medium flex-1 ${
// //                   activeTab === "video"
// //                     ? "text-indigo-600 border-b-2 border-indigo-600"
// //                     : "text-gray-500 hover:text-gray-700"
// //                 }`}
// //                 onClick={() => setActiveTab("video")}
// //               >
// //                 Chat
// //               </button>
// //               <button
// //                 className={`py-2 px-4 text-center text-sm font-medium flex-1 ${
// //                   activeTab === "qa"
// //                     ? "text-indigo-600 border-b-2 border-indigo-600"
// //                     : "text-gray-500 hover:text-gray-700"
// //                 }`}
// //                 onClick={() => setActiveTab("qa")}
// //               >
// //                 Q&A
// //               </button>
// //               <button
// //                 className={`py-2 px-4 text-center text-sm font-medium flex-1 ${
// //                   activeTab === "participants"
// //                     ? "text-indigo-600 border-b-2 border-indigo-600"
// //                     : "text-gray-500 hover:text-gray-700"
// //                 }`}
// //                 onClick={() => setActiveTab("participants")}
// //               >
// //                 People
// //               </button>
// //             </div>
// //           </div>

// //           {/* Chat tab */}
// //           {activeTab === "video" && (
// //             <div className="flex flex-col h-full">
// //               <div
// //                 className="flex-grow overflow-y-auto p-3 space-y-3"
// //                 ref={chatContainerRef}
// //               >
// //                 {chatMessages.map((message) => (
// //                   <div
// //                     key={message.id}
// //                     className={`flex ${message.isYou ? "justify-end" : ""}`}
// //                   >
// //                     <div
// //                       className={`max-w-3/4 ${message.isYou ? "order-2" : ""}`}
// //                     >
// //                       <div className="flex items-end">
// //                         {!message.isYou && (
// //                           <div className="flex-shrink-0 mr-2">
// //                             <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden">
// //                               <img
// //                                 src={
// //                                   message.avatar ||
// //                                   "/images/avatars/default-avatar.jpg"
// //                                 }
// //                                 alt={message.sender}
// //                                 className="h-full w-full object-cover"
// //                               />
// //                             </div>
// //                           </div>
// //                         )}
// //                         <div>
// //                           <div
// //                             className={`rounded-lg px-3 py-2 ${
// //                               message.role === "Instructor"
// //                                 ? "bg-indigo-100 text-indigo-800"
// //                                 : message.role === "Teaching Assistant"
// //                                 ? "bg-purple-100 text-purple-800"
// //                                 : message.isYou
// //                                 ? "bg-blue-100 text-blue-800"
// //                                 : "bg-gray-100 text-gray-800"
// //                             }`}
// //                           >
// //                             <div className="text-xs font-medium flex justify-between mb-1">
// //                               <span>
// //                                 {message.sender}
// //                                 {message.role !== "Student" && (
// //                                   <span className="ml-1 text-xs opacity-75">
// //                                     ({message.role})
// //                                   </span>
// //                                 )}
// //                               </span>
// //                               <span className="text-xs opacity-75">
// //                                 {message.time}
// //                               </span>
// //                             </div>
// //                             <p className="text-sm whitespace-pre-wrap break-words">
// //                               {message.message}
// //                             </p>
// //                           </div>
// //                         </div>
// //                         {message.isYou && (
// //                           <div className="flex-shrink-0 ml-2">
// //                             <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden">
// //                               <img
// //                                 src={
// //                                   message.avatar ||
// //                                   "/images/avatars/default-avatar.jpg"
// //                                 }
// //                                 alt={message.sender}
// //                                 className="h-full w-full object-cover"
// //                               />
// //                             </div>
// //                           </div>
// //                         )}
// //                       </div>
// //                     </div>
// //                   </div>
// //                 ))}
// //                 {chatMessages.length === 0 && (
// //                   <div className="flex flex-col items-center justify-center h-full text-gray-500">
// //                     <svg
// //                       className="h-12 w-12 mb-2"
// //                       fill="none"
// //                       viewBox="0 0 24 24"
// //                       stroke="currentColor"
// //                     >
// //                       <path
// //                         strokeLinecap="round"
// //                         strokeLinejoin="round"
// //                         strokeWidth={1}
// //                         d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
// //                       />
// //                     </svg>
// //                     <p className="text-sm">No messages yet</p>
// //                   </div>
// //                 )}
// //               </div>
// //               <div className="p-3 border-t border-gray-200">
// //                 <form onSubmit={handleSendMessage} className="flex">
// //                   <input
// //                     type="text"
// //                     placeholder="Type a message..."
// //                     value={newMessage}
// //                     onChange={(e) => setNewMessage(e.target.value)}
// //                     className="flex-grow border border-gray-300 rounded-l-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
// //                   />
// //                   <button
// //                     type="submit"
// //                     className="bg-indigo-600 text-white px-3 py-2 rounded-r-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
// //                   >
// //                     <svg
// //                       className="h-5 w-5"
// //                       fill="none"
// //                       viewBox="0 0 24 24"
// //                       stroke="currentColor"
// //                     >
// //                       <path
// //                         strokeLinecap="round"
// //                         strokeLinejoin="round"
// //                         strokeWidth={2}
// //                         d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
// //                       />
// //                     </svg>
// //                   </button>
// //                 </form>
// //               </div>
// //             </div>
// //           )}

// //           {/* Q&A tab */}
// //           {activeTab === "qa" && (
// //             <div className="flex flex-col h-full">
// //               <div
// //                 className="flex-grow overflow-y-auto p-3 space-y-3"
// //                 ref={questionContainerRef}
// //               >
// //                 {sortedQuestions.map((question) => (
// //                   <div
// //                     key={question.id}
// //                     className="bg-white rounded-lg border border-gray-200 shadow-sm"
// //                   >
// //                     <div className="p-3">
// //                       <div className="flex items-start justify-between mb-2">
// //                         <div className="flex items-center">
// //                           <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden mr-2">
// //                             <img
// //                               src={
// //                                 question.avatar ||
// //                                 "/images/avatars/default-avatar.jpg"
// //                               }
// //                               alt={question.sender}
// //                               className="h-full w-full object-cover"
// //                             />
// //                           </div>
// //                           <div>
// //                             <div className="text-sm font-medium">
// //                               {question.sender}
// //                             </div>
// //                             <div className="text-xs text-gray-500">
// //                               {question.time}
// //                             </div>
// //                           </div>
// //                         </div>
// //                         <button
// //                           onClick={() => upvoteQuestion(question.id)}
// //                           className={`px-2 py-1 rounded-full flex items-center ${
// //                             question.isYou
// //                               ? "bg-gray-200 cursor-not-allowed"
// //                               : "bg-gray-100 hover:bg-gray-200"
// //                           }`}
// //                           disabled={question.isYou}
// //                         >
// //                           <svg
// //                             className="h-4 w-4 text-gray-600 mr-1"
// //                             fill="none"
// //                             viewBox="0 0 24 24"
// //                             stroke="currentColor"
// //                           >
// //                             <path
// //                               strokeLinecap="round"
// //                               strokeLinejoin="round"
// //                               strokeWidth={2}
// //                               d="M5 15l7-7 7 7"
// //                             />
// //                           </svg>
// //                           <span className="text-xs font-medium">
// //                             {question.upvotes}
// //                           </span>
// //                         </button>
// //                       </div>
// //                       <p className="text-sm mb-2">{question.question}</p>
// //                       {question.isAnswered && (
// //                         <div className="bg-indigo-50 p-2 rounded-md mt-2 border-l-2 border-indigo-500">
// //                           <div className="text-xs font-medium text-indigo-800 mb-1">
// //                             Answer from instructor:
// //                           </div>
// //                           <p className="text-sm text-gray-700">
// //                             {question.answer}
// //                           </p>
// //                         </div>
// //                       )}
// //                     </div>
// //                   </div>
// //                 ))}
// //                 {questionMessages.length === 0 && (
// //                   <div className="flex flex-col items-center justify-center h-full text-gray-500">
// //                     <svg
// //                       className="h-12 w-12 mb-2"
// //                       fill="none"
// //                       viewBox="0 0 24 24"
// //                       stroke="currentColor"
// //                     >
// //                       <path
// //                         strokeLinecap="round"
// //                         strokeLinejoin="round"
// //                         strokeWidth={1}
// //                         d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
// //                       />
// //                     </svg>
// //                     <p className="text-sm">No questions yet</p>
// //                   </div>
// //                 )}
// //               </div>
// //               <div className="p-3 border-t border-gray-200">
// //                 <form onSubmit={handleSendQuestion} className="flex flex-col">
// //                   <textarea
// //                     placeholder="Ask a question..."
// //                     value={newQuestion}
// //                     onChange={(e) => setNewQuestion(e.target.value)}
// //                     className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 min-h-[80px]"
// //                   ></textarea>
// //                   <button
// //                     type="submit"
// //                     className="mt-2 bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 text-sm"
// //                   >
// //                     Submit Question
// //                   </button>
// //                 </form>
// //               </div>
// //             </div>
// //           )}

// //           {/* Participants tab */}
// //           {activeTab === "participants" && (
// //             <div className="h-full overflow-y-auto p-3">
// //               <div className="mb-4">
// //                 <h3 className="text-sm font-medium text-gray-700 mb-2">
// //                   Hosts & Presenters
// //                 </h3>
// //                 <div className="space-y-2">
// //                   {participants
// //                     .filter(
// //                       (p) =>
// //                         p.role === "Instructor" ||
// //                         p.role === "Teaching Assistant"
// //                     )
// //                     .map((participant) => (
// //                       <div
// //                         key={participant.id}
// //                         className="flex items-center justify-between"
// //                       >
// //                         <div className="flex items-center">
// //                           <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden mr-2">
// //                             <img
// //                               src={
// //                                 participant.avatar ||
// //                                 "/images/avatars/default-avatar.jpg"
// //                               }
// //                               alt={participant.name}
// //                               className="h-full w-full object-cover"
// //                             />
// //                           </div>
// //                           <div>
// //                             <div className="text-sm font-medium">
// //                               {participant.name}
// //                               {participant.isYou && (
// //                                 <span className="ml-1 text-xs">(You)</span>
// //                               )}
// //                             </div>
// //                             <div className="text-xs text-gray-500">
// //                               {participant.role}
// //                             </div>
// //                           </div>
// //                         </div>
// //                         {participant.isHost && (
// //                           <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
// //                             Host
// //                           </span>
// //                         )}
// //                       </div>
// //                     ))}
// //                 </div>
// //               </div>

// //               <div>
// //                 <h3 className="text-sm font-medium text-gray-700 mb-2">
// //                   Students (
// //                   {participants.filter((p) => p.role === "Student").length})
// //                 </h3>
// //                 <div className="space-y-2">
// //                   {participants
// //                     .filter((p) => p.role === "Student")
// //                     .map((participant) => (
// //                       <div
// //                         key={participant.id}
// //                         className="flex items-center justify-between"
// //                       >
// //                         <div className="flex items-center">
// //                           <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden mr-2">
// //                             <img
// //                               src={
// //                                 participant.avatar ||
// //                                 "/images/avatars/default-avatar.jpg"
// //                               }
// //                               alt={participant.name}
// //                               className="h-full w-full object-cover"
// //                             />
// //                           </div>
// //                           <div className="text-sm">
// //                             {participant.name}
// //                             {participant.isYou && (
// //                               <span className="ml-1 text-xs">(You)</span>
// //                             )}
// //                           </div>
// //                         </div>
// //                         {participant.isHandRaised && (
// //                           <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
// //                             <svg
// //                               className="h-3 w-3 mr-1"
// //                               fill="none"
// //                               viewBox="0 0 24 24"
// //                               stroke="currentColor"
// //                             >
// //                               <path
// //                                 strokeLinecap="round"
// //                                 strokeLinejoin="round"
// //                                 strokeWidth={2}
// //                                 d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
// //                               />
// //                             </svg>
// //                             Hand Raised
// //                           </span>
// //                         )}
// //                       </div>
// //                     ))}
// //                 </div>
// //               </div>
// //             </div>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default LiveClassPage;

// // pages/LiveClassPage.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import AgoraRTC from "agora-rtc-sdk-ng";
// import { motion } from "framer-motion";
// import { CONSTANTS } from "../constants/Constants";

// const LiveClassPage = () => {
//   const navigate = useNavigate();
//   // const { classId } = useParams();
//   const classId = "67f79cbd572ad45888203586";
//   const [isLoading, setIsLoading] = useState(true);
//   const [classData, setClassData] = useState(null);
//   const [activeTab, setActiveTab] = useState("video");
//   const [chatMessages, setChatMessages] = useState([]);
//   const [questionMessages, setQuestionMessages] = useState([]);
//   const [newMessage, setNewMessage] = useState("");
//   const [newQuestion, setNewQuestion] = useState("");
//   const [isMicMuted, setIsMicMuted] = useState(true);
//   const [isCameraOff, setIsCameraOff] = useState(true);
//   const [isScreenSharing, setIsScreenSharing] = useState(false);
//   const [isHandRaised, setIsHandRaised] = useState(false);
//   const [isFullScreen, setIsFullScreen] = useState(false);
//   const [isRecording, setIsRecording] = useState(false);
//   const [participants, setParticipants] = useState([]);
//   const [isResourcesPanelOpen, setIsResourcesPanelOpen] = useState(false);
//   const [showNotes, setShowNotes] = useState(false);

//   // Agora states
//   const [agoraEngine, setAgoraEngine] = useState(null);
//   const [localVideoTrack, setLocalVideoTrack] = useState(null);
//   const [localAudioTrack, setLocalAudioTrack] = useState(null);
//   const [screenShareTrack, setScreenShareTrack] = useState(null);
//   const [remoteUsers, setRemoteUsers] = useState([]);
//   const [joinState, setJoinState] = useState(false);
//   const [networkQuality, setNetworkQuality] = useState(5); // 0-5 scale
//   const [recordingState, setRecordingState] = useState({
//     isRecording: false,
//     recordingUid: null,
//     resourceId: null,
//     sid: null,
//   });

//   // Moderator states
//   const [isModeratorPresent, setIsModeratorPresent] = useState(false);
//   const [waitingForModerator, setWaitingForModerator] = useState(true);
//   const [isUserModerator, setIsUserModerator] = useState(false);

//   // Refs
//   const videoContainerRef = useRef(null);
//   const chatContainerRef = useRef(null);
//   const questionContainerRef = useRef(null);
//   const localPlayerRef = useRef(null);
//   const remotePlayerRefs = useRef({});

//   // Agora client configuration
//   const appId = "b4cd9bdc7f94480ba3d1b6262e54d9ad"; // Replace with your Agora App ID in production
//   // const rtcClientConfig = {
//   //   mode: "rtc", // Real-time communication mode
//   //   codec: "vp8", // Video codec
//   //   role: "audience", // Default role, will change based on user type
//   // };
//   const rtcClientConfig = {
//     mode: "live", // Change to 'live' mode which supports roles
//     codec: "vp8", // Video codec
//   };

//   // Initialize Agora engine
//   useEffect(() => {
//     // Create an instance of the Agora engine
//     const agoraEngineInstance = AgoraRTC.createClient(rtcClientConfig);
//     setAgoraEngine(agoraEngineInstance);

//     // Set up event listeners
//     agoraEngineInstance.on("user-published", handleUserPublished);
//     agoraEngineInstance.on("user-unpublished", handleUserUnpublished);
//     agoraEngineInstance.on("user-joined", handleUserJoined);
//     agoraEngineInstance.on("user-left", handleUserLeft);
//     agoraEngineInstance.on("network-quality", handleNetworkQuality);
//     agoraEngineInstance.on("exception", handleException);
//     agoraEngineInstance.on(
//       "connection-state-change",
//       handleConnectionStateChange
//     );

//     // Cleanup function
//     return () => {
//       // Remove event listeners
//       agoraEngineInstance.removeAllListeners();

//       // Leave the channel when component unmounts
//       if (joinState) {
//         leaveChannel();
//       }
//     };
//   }, []);

//   // Fetch class data
//   useEffect(() => {
//     // In a real app, fetch from API
//     const fetchClassData = async () => {
//       try {
//         // Simulate API call to fetch class data
//         // In production, replace with actual API call
//         setTimeout(() => {
//           const mockClassData = {
//             id: classId || "12345",
//             title: "Constitutional Law and Polity for NPSC",
//             instructor: "Dr. Imtisunep Ao",
//             instructorRole: "Constitutional Expert",
//             status: "waiting", // waiting, live, scheduled, ended
//             startTime: "10:00 AM",
//             duration: "2 hours",
//             participants: 86,
//             description:
//               "This session focuses on key constitutional topics relevant to the NPSC examination, including fundamental rights, directive principles, and constitutional amendments.",
//             moderatorIds: [123456, 200002], // IDs of moderators (instructor and TA)
//           };

//           setClassData(mockClassData);

//           // Mock participants data
//           const mockParticipants = [
//             {
//               id: 1,
//               name: "Dr. Imtisunep Ao",
//               role: "Instructor",
//               isHost: true,
//               isModerator: true,
//               avatar: "/images/faculty/instructor-1.jpg",
//               uid: 123456, // Agora user ID for the instructor
//             },
//             {
//               id: 2,
//               name: "You",
//               role: "Student",
//               isYou: true,
//               isModerator: false, // Change to true for testing moderator features
//               avatar: "/images/avatars/default-avatar.jpg",
//               uid: 200001, // Your Agora user ID
//             },
//             {
//               id: 3,
//               name: "Kevichulie Liegise",
//               role: "Student",
//               isModerator: false,
//               avatar: "/images/students/student-1.jpg",
//               uid: 300001,
//             },
//             {
//               id: 4,
//               name: "Atsungla Aier",
//               role: "Student",
//               isModerator: false,
//               avatar: "/images/students/student-2.jpg",
//               uid: 300002,
//             },
//             {
//               id: 5,
//               name: "Vikali Zhimomi",
//               role: "Teaching Assistant",
//               isModerator: true,
//               avatar: "/images/faculty/ta-1.jpg",
//               uid: 200002,
//             },
//             {
//               id: 6,
//               name: "Thejangulie Zao",
//               role: "Student",
//               isModerator: false,
//               avatar: "/images/students/student-3.jpg",
//               uid: 300003,
//             },
//             {
//               id: 7,
//               name: "Keneilelie Kire",
//               role: "Student",
//               isModerator: false,
//               avatar: "/images/students/student-4.jpg",
//               uid: 300004,
//             },
//             {
//               id: 8,
//               name: "Neikehielie Rio",
//               role: "Student",
//               isModerator: false,
//               avatar: "/images/students/student-5.jpg",
//               uid: 300005,
//             },
//           ];

//           setParticipants(mockParticipants);

//           // Check if current user is a moderator
//           const currentUser = mockParticipants.find((p) => p.isYou);
//           if (currentUser && currentUser.isModerator) {
//             setIsUserModerator(true);
//           }

//           // Mock chat messages
//           setChatMessages([
//             {
//               id: 1,
//               sender: "System",
//               role: "System",
//               message:
//                 "Welcome to the class. Please wait for the moderator to start the session.",
//               time: new Date().toLocaleTimeString([], {
//                 hour: "2-digit",
//                 minute: "2-digit",
//               }),
//               isSystem: true,
//             },
//           ]);

//           setIsLoading(false);
//         }, 1500);
//       } catch (error) {
//         console.error("Error fetching class data:", error);
//         setIsLoading(false);
//       }
//     };

//     fetchClassData();
//   }, [classId]);

//   // Check for active moderators
//   useEffect(() => {
//     if (!remoteUsers.length) return;

//     const moderatorIds = classData?.moderatorIds || [];
//     const activeModerators = remoteUsers.filter((user) =>
//       moderatorIds.includes(user.uid)
//     );

//     if (activeModerators.length > 0) {
//       setIsModeratorPresent(true);
//       if (waitingForModerator) {
//         // Add system message that class has started
//         const moderatorName =
//           participants.find((p) => p.uid === activeModerators[0].uid)?.name ||
//           "Instructor";
//         const newMessage = {
//           id: chatMessages.length + 1,
//           sender: "System",
//           role: "System",
//           message: `${moderatorName} has joined. The class is now in session.`,
//           time: new Date().toLocaleTimeString([], {
//             hour: "2-digit",
//             minute: "2-digit",
//           }),
//           isSystem: true,
//         };

//         setChatMessages((prev) => [...prev, newMessage]);
//         setWaitingForModerator(false);

//         // Update class status
//         if (classData) {
//           setClassData({
//             ...classData,
//             status: "live",
//           });
//         }
//       }
//     } else {
//       // Check if we were previously in a session with a moderator
//       if (!waitingForModerator && !isUserModerator) {
//         const newMessage = {
//           id: chatMessages.length + 1,
//           sender: "System",
//           role: "System",
//           message: "The moderator has left. Waiting for moderator to rejoin...",
//           time: new Date().toLocaleTimeString([], {
//             hour: "2-digit",
//             minute: "2-digit",
//           }),
//           isSystem: true,
//         };

//         setChatMessages((prev) => [...prev, newMessage]);
//         setWaitingForModerator(true);
//         setIsModeratorPresent(false);

//         // Update class status
//         if (classData) {
//           setClassData({
//             ...classData,
//             status: "waiting",
//           });
//         }
//       }
//     }
//   }, [remoteUsers, classData, waitingForModerator, isUserModerator]);

//   // Get token from server
//   const getAgoraToken = async (uid) => {
//     try {
      
//       const response = await fetch(`${CONSTANTS.APIURL}/api/agora/token`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           channelName: classId,
//           uid: uid,
//           role: "publisher", // or 'audience' based on user role
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to get token");
//       }

//       const data = await response.json();
//       return data.token;
//     } catch (error) {
//       console.error("Error fetching token:", error);
//       // For development/demo only - never use hardcoded tokens in production
//       return "dummy-token-for-development";
//     }
//   };

//   // Join the Agora channel
//   // const joinChannel = async () => {
//   //   if (!agoraEngine) return;

//   //   try {
//   //     setIsLoading(true);

//   //     // Get current user details
//   //     const currentUser = participants.find((p) => p.isYou);
//   //     if (!currentUser) {
//   //       console.error("Current user not found");
//   //       setIsLoading(false);
//   //       return;
//   //     }

//   //     // Determine if user is moderator
//   //     const isModerator = currentUser.isModerator;

//   //     // Set client role based on user type
//   //     if (agoraEngine.mode === "live") {
//   //       if (isModerator) {
//   //         await agoraEngine.setClientRole("host");
//   //       } else {
//   //         await agoraEngine.setClientRole("audience");
//   //       }
//   //     }

//   //     // Get a token from your token server
//   //     const token = await getAgoraToken(currentUser.uid);

//   //     // Join the channel
//   //     await agoraEngine.join(appId, classId, token, currentUser.uid);

//   //     // Update join state
//   //     setJoinState(true);

//   //     // If user is a moderator, create and publish tracks
//   //     if (isModerator) {
//   //       // Create audio and video tracks
//   //       const audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
//   //       const videoTrack = await AgoraRTC.createCameraVideoTrack();

//   //       // Set local tracks
//   //       setLocalAudioTrack(audioTrack);
//   //       setLocalVideoTrack(videoTrack);

//   //       // Mute by default
//   //       audioTrack.setEnabled(false);
//   //       setIsMicMuted(true);

//   //       // Play local video
//   //       if (localPlayerRef.current) {
//   //         videoTrack.play(localPlayerRef.current);
//   //       }

//   //       // Publish tracks
//   //       await agoraEngine.publish([audioTrack, videoTrack]);

//   //       // Update moderator presence
//   //       setIsModeratorPresent(true);
//   //       setWaitingForModerator(false);

//   //       // Update class status if user is moderator
//   //       if (classData) {
//   //         setClassData({
//   //           ...classData,
//   //           status: "live",
//   //         });
//   //       }

//   //       // Add system message
//   //       const newMessage = {
//   //         id: chatMessages.length + 1,
//   //         sender: "System",
//   //         role: "System",
//   //         message: "You have started the class as a moderator.",
//   //         time: new Date().toLocaleTimeString([], {
//   //           hour: "2-digit",
//   //           minute: "2-digit",
//   //         }),
//   //         isSystem: true,
//   //       };

//   //       setChatMessages((prev) => [...prev, newMessage]);
//   //     }

//   //     setIsLoading(false);
//   //   } catch (error) {
//   //     console.error("Error joining channel:", error);
//   //     setIsLoading(false);

//   //     // Add error message to chat
//   //     const errorMessage = {
//   //       id: chatMessages.length + 1,
//   //       sender: "System",
//   //       role: "System",
//   //       message: "Failed to join the class. Please try refreshing the page.",
//   //       time: new Date().toLocaleTimeString([], {
//   //         hour: "2-digit",
//   //         minute: "2-digit",
//   //       }),
//   //       isSystem: true,
//   //       isError: true,
//   //     };

//   //     setChatMessages((prev) => [...prev, errorMessage]);
//   //   }
//   // };
//   const joinChannel = async () => {
//     if (!agoraEngine) return;
    
//     // Check current connection state to avoid duplicate join attempts
//     if (agoraEngine.connectionState === "CONNECTED" || agoraEngine.connectionState === "CONNECTING") {
//       console.log("Already connected or connecting to Agora, not joining again");
//       setJoinState(true);
//       setIsLoading(false);
//       return;
//     }
  
//     try {
//       setIsLoading(true);
  
//       // Get current user details
//       const currentUser = participants.find((p) => p.isYou);
//       if (!currentUser) {
//         console.error("Current user not found");
//         setIsLoading(false);
//         return;
//       }
  
//       // Determine if user is moderator
//       const isModerator = currentUser.isModerator;
  
//       // Generate a unique UID to avoid conflicts
//       const uniqueUid = currentUser.uid + Math.floor(Math.random() * 1000);
//       console.log(`Joining channel ${classId} with UID: ${uniqueUid}`);
  
//       // Set client role based on user type
//       if (agoraEngine.mode === "live") {
//         if (isModerator) {
//           await agoraEngine.setClientRole("host");
//         } else {
//           await agoraEngine.setClientRole("audience");
//         }
//       }
  
//       // Get a token from your token server (or use null for testing)
//       const token = null; // For testing, replace with getAgoraToken when API is ready
  
//       // Join the channel with the unique UID
//       await agoraEngine.join(appId, classId, token, currentUser.uid);
  
//       // Update join state
//       setJoinState(true);
  
//       // If user is a moderator, create and publish tracks
//       if (isModerator) {
//         try {
//           // Create audio and video tracks
//           const audioTrack = await AgoraRTC.createMicrophoneAudioTrack();
//           const videoTrack = await AgoraRTC.createCameraVideoTrack();
  
//           // Set local tracks
//           setLocalAudioTrack(audioTrack);
//           setLocalVideoTrack(videoTrack);
  
//           // Mute by default
//           audioTrack.setEnabled(false);
//           setIsMicMuted(true);
  
//           // Play local video
//           if (localPlayerRef.current) {
//             videoTrack.play(localPlayerRef.current);
//           }
  
//           // Publish tracks
//           await agoraEngine.publish([audioTrack, videoTrack]);
  
//           // Update moderator presence
//           setIsModeratorPresent(true);
//           setWaitingForModerator(false);
  
//           // Update class status if user is moderator
//           if (classData) {
//             setClassData({
//               ...classData,
//               status: "live",
//             });
//           }
  
//           // Add system message
//           const newMessage = {
//             id: chatMessages.length + 1,
//             sender: "System",
//             role: "System",
//             message: "You have started the class as a moderator.",
//             time: new Date().toLocaleTimeString([], {
//               hour: "2-digit",
//               minute: "2-digit",
//             }),
//             isSystem: true,
//           };
  
//           setChatMessages((prev) => [...prev, newMessage]);
//         } catch (trackError) {
//           console.error("Error creating media tracks:", trackError);
          
//           // Add error message about devices
//           const deviceErrorMessage = {
//             id: chatMessages.length + 1,
//             sender: "System",
//             role: "System",
//             message: "Couldn't access camera or microphone. Please check your device permissions.",
//             time: new Date().toLocaleTimeString([], {
//               hour: "2-digit",
//               minute: "2-digit",
//             }),
//             isSystem: true,
//             isError: true,
//           };
          
//           setChatMessages((prev) => [...prev, deviceErrorMessage]);
//         }
//       }
  
//       setIsLoading(false);
//     } catch (error) {
//       console.error("Error joining channel:", error);
//       setIsLoading(false);
  
//       // Add error message to chat
//       const errorMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: "Failed to join the class. Please try refreshing the page.",
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//         isError: true,
//       };
  
//       setChatMessages((prev) => [...prev, errorMessage]);
//     }
//   };
//   // Leave the Agora channel
//   const leaveChannel = async () => {
//     if (!agoraEngine) return;

//     try {
//       // If moderator is leaving, notify others
//       const currentUser = participants.find((p) => p.isYou);
//       if (currentUser && currentUser.isModerator && remoteUsers.length > 0) {
//         // In production, send a signal to other users through RTM
//         console.log("Moderator leaving the channel");
//       }

//       // Unpublish and close local tracks
//       if (localAudioTrack) {
//         await agoraEngine.unpublish(localAudioTrack);
//         localAudioTrack.close();
//         setLocalAudioTrack(null);
//       }

//       if (localVideoTrack) {
//         await agoraEngine.unpublish(localVideoTrack);
//         localVideoTrack.close();
//         setLocalVideoTrack(null);
//       }

//       // Stop screen sharing if active
//       if (screenShareTrack) {
//         await agoraEngine.unpublish(screenShareTrack);
//         screenShareTrack.close();
//         setScreenShareTrack(null);
//         setIsScreenSharing(false);
//       }

//       // Stop recording if active
//       if (recordingState.isRecording) {
//         await stopRecording();
//       }

//       // Leave the channel
//       await agoraEngine.leave();

//       // Reset state
//       setJoinState(false);
//       setRemoteUsers([]);

//       // Add leave message
//       const leaveMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: "You have left the class.",
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//       };

//       setChatMessages((prev) => [...prev, leaveMessage]);
//     } catch (error) {
//       console.error("Error leaving channel:", error);
//     }
//   };

//   // Handle connection state changes
//   const handleConnectionStateChange = (curState, prevState, reason) => {
//     console.log(
//       "Connection state changed:",
//       prevState,
//       "->",
//       curState,
//       "reason:",
//       reason
//     );

//     if (curState === "DISCONNECTED") {
//       // Handle disconnection
//       const disconnectMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: `You have been disconnected: ${reason}. Attempting to reconnect...`,
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//         isWarning: true,
//       };

//       setChatMessages((prev) => [...prev, disconnectMessage]);
//     } else if (curState === "CONNECTED") {
//       // Handle successful connection/reconnection
//       if (prevState === "RECONNECTING") {
//         const reconnectMessage = {
//           id: chatMessages.length + 1,
//           sender: "System",
//           role: "System",
//           message: "Successfully reconnected to the class.",
//           time: new Date().toLocaleTimeString([], {
//             hour: "2-digit",
//             minute: "2-digit",
//           }),
//           isSystem: true,
//           isSuccess: true,
//         };

//         setChatMessages((prev) => [...prev, reconnectMessage]);
//       }
//     }
//   };

//   // Toggle microphone (for moderators)
//   const toggleMic = async () => {
//     if (!localAudioTrack) return;

//     try {
//       const enabled = !isMicMuted;
//       await localAudioTrack.setEnabled(enabled);
//       setIsMicMuted(!enabled);
//     } catch (error) {
//       console.error("Error toggling microphone:", error);
//     }
//   };

//   // Toggle camera (for moderators)
//   const toggleCamera = async () => {
//     if (!localVideoTrack) return;

//     try {
//       const enabled = isCameraOff;
//       await localVideoTrack.setEnabled(enabled);
//       setIsCameraOff(!enabled);
//     } catch (error) {
//       console.error("Error toggling camera:", error);
//     }
//   };

//   // Toggle screen sharing (for moderators)
//   const toggleScreenSharing = async () => {
//     if (!agoraEngine) return;

//     try {
//       if (isScreenSharing) {
//         // Stop screen sharing
//         if (screenShareTrack) {
//           await agoraEngine.unpublish(screenShareTrack);
//           screenShareTrack.close();
//           setScreenShareTrack(null);
//         }
//       } else {
//         // Start screen sharing
//         const screenTrack = await AgoraRTC.createScreenVideoTrack();

//         // Handle when user stops sharing via browser UI
//         screenTrack.on("track-ended", () => {
//           setIsScreenSharing(false);
//           agoraEngine.unpublish(screenTrack);
//           screenTrack.close();
//           setScreenShareTrack(null);
//         });

//         // Publish screen track
//         await agoraEngine.publish(screenTrack);
//         setScreenShareTrack(screenTrack);
//       }

//       setIsScreenSharing(!isScreenSharing);
//     } catch (error) {
//       console.error("Error toggling screen sharing:", error);
//       // If user cancels screen sharing selection
//       if (error.name === "NotAllowedError") {
//         console.log("User cancelled screen sharing selection");
//       }
//     }
//   };

//   // Start recording (for moderators)
//   const startRecording = async () => {
//     try {
//       const currentUser = participants.find((p) => p.isYou);

//       const response = await fetch("/api/agora/recording/start", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           channelName: classId,
//           uid: currentUser.uid,
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to start recording");
//       }

//       const data = await response.json();

//       setRecordingState({
//         isRecording: true,
//         recordingUid: data.uid,
//         resourceId: data.resourceId,
//         sid: data.sid,
//       });

//       setIsRecording(true);

//       // Notify participants about recording
//       const recordingMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: "This session is now being recorded.",
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//       };

//       setChatMessages((prev) => [...prev, recordingMessage]);
//     } catch (error) {
//       console.error("Error starting recording:", error);
//     }
//   };

//   // Stop recording (for moderators)
//   const stopRecording = async () => {
//     try {
//       if (!recordingState.resourceId || !recordingState.sid) {
//         throw new Error("Recording information missing");
//       }

//       const response = await fetch("/api/agora/recording/stop", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           channelName: classId,
//           resourceId: recordingState.resourceId,
//           sid: recordingState.sid,
//         }),
//       });

//       if (!response.ok) {
//         throw new Error("Failed to stop recording");
//       }

//       setRecordingState({
//         isRecording: false,
//         recordingUid: null,
//         resourceId: null,
//         sid: null,
//       });

//       setIsRecording(false);

//       // Notify participants about stopped recording
//       const recordingStoppedMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message:
//           "Recording has stopped. The video will be available after processing.",
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//       };

//       setChatMessages((prev) => [...prev, recordingStoppedMessage]);
//     } catch (error) {
//       console.error("Error stopping recording:", error);
//     }
//   };

//   // Handle remote user published media
//   const handleUserPublished = async (user, mediaType) => {
//     // Subscribe to the remote user
//     await agoraEngine?.subscribe(user, mediaType);

//     // Update remote users list
//     setRemoteUsers((prevUsers) => {
//       // Check if user already exists
//       if (prevUsers.some((u) => u.uid === user.uid)) {
//         return prevUsers.map((u) =>
//           u.uid === user.uid
//             ? {
//                 ...u,
//                 hasAudio: mediaType === "audio" ? true : u.hasAudio,
//                 hasVideo: mediaType === "video" ? true : u.hasVideo,
//               }
//             : u
//         );
//       } else {
//         // Find user in participants
//         const participant = participants.find((p) => p.uid === user.uid);
//         return [
//           ...prevUsers,
//           {
//             uid: user.uid,
//             videoTrack: mediaType === "video" ? user.videoTrack : null,
//             audioTrack: mediaType === "audio" ? user.audioTrack : null,
//             hasAudio: mediaType === "audio",
//             hasVideo: mediaType === "video",
//             name: participant ? participant.name : `User ${user.uid}`,
//             role: participant ? participant.role : "Student",
//             avatar: participant
//               ? participant.avatar
//               : "/images/avatars/default-avatar.jpg",
//             isModerator: participant ? participant.isModerator : false,
//           },
//         ];
//       }
//     });

//     // Play media if it's video
//     if (mediaType === "video") {
//       // Create a div for the user if it doesn't exist
//       const playerElement = document.getElementById(`player-${user.uid}`);
//       if (playerElement) {
//         user.videoTrack.play(playerElement);
//       }
//     }
//   };

//   // Handle remote user unpublished media
//   const handleUserUnpublished = (user, mediaType) => {
//     // Update remote users list
//     setRemoteUsers((prevUsers) => {
//       return prevUsers.map((u) => {
//         if (u.uid === user.uid) {
//           return {
//             ...u,
//             hasAudio: mediaType === "audio" ? false : u.hasAudio,
//             hasVideo: mediaType === "video" ? false : u.hasVideo,
//             videoTrack: mediaType === "video" ? null : u.videoTrack,
//             audioTrack: mediaType === "audio" ? null : u.audioTrack,
//           };
//         }
//         return u;
//       });
//     });
//   };

//   // Handle remote user joined
//   const handleUserJoined = (user) => {
//     console.log("User joined:", user.uid);

//     // Find participant info
//     const participant = participants.find((p) => p.uid === user.uid);

//     // Add system message
//     if (participant) {
//       const joinMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: `${participant.name} (${participant.role}) has joined the class.`,
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//       };

//       setChatMessages((prev) => [...prev, joinMessage]);
//     }

//     // Update participants count
//     if (classData) {
//       setClassData({
//         ...classData,
//         participants: classData.participants + 1,
//       });
//     }
//   };

//   // Handle remote user left
//   const handleUserLeft = (user) => {
//     console.log("User left:", user.uid);

//     // Find user before removing
//     const leftUser = remoteUsers.find((u) => u.uid === user.uid);
//     const participant = participants.find((p) => p.uid === user.uid);

//     // Add system message
//     if (participant) {
//       const leaveMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: `${participant.name} (${participant.role}) has left the class.`,
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//       };

//       setChatMessages((prev) => [...prev, leaveMessage]);
//     }

//     // Remove user from remote users list
//     setRemoteUsers((prevUsers) => prevUsers.filter((u) => u.uid !== user.uid));

//     // Update participants count
//     if (classData) {
//       setClassData({
//         ...classData,
//         participants: Math.max(0, classData.participants - 1),
//       });
//     }
//   };

//   // Handle network quality updates
//   const handleNetworkQuality = (stats) => {
//     setNetworkQuality(stats.downlinkNetworkQuality);
//   };

//   // Handle exceptions
//   const handleException = (event) => {
//     console.error("Agora exception:", event);

//     // Add error message for serious exceptions
//     if (event.code >= 1000) {
//       // Critical errors usually have codes >= 1000
//       const errorMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: `Connection issue detected (code: ${event.code}). You may experience disruptions.`,
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//         isError: true,
//       };

//       setChatMessages((prev) => [...prev, errorMessage]);
//     }
//   };

//   // Auto-join channel when class data is loaded
//   useEffect(() => {
//     if (classData && agoraEngine && !joinState) {
//       joinChannel();
//     }
//   }, [classData, agoraEngine]);

//   // Auto-scroll chat to bottom when new messages are added
//   useEffect(() => {
//     if (chatContainerRef.current) {
//       chatContainerRef.current.scrollTop =
//         chatContainerRef.current.scrollHeight;
//     }
//   }, [chatMessages]);

//   // Auto-scroll question container when new questions are added
//   useEffect(() => {
//     if (questionContainerRef.current) {
//       questionContainerRef.current.scrollTop =
//         questionContainerRef.current.scrollHeight;
//     }
//   }, [questionMessages]);

//   const handleSendMessage = (e) => {
//     e.preventDefault();
//     if (!newMessage.trim()) return;

//     const newChatMessage = {
//       id: chatMessages.length + 1,
//       sender: "You",
//       role: "Student",
//       message: newMessage,
//       time: new Date().toLocaleTimeString([], {
//         hour: "2-digit",
//         minute: "2-digit",
//       }),
//       isYou: true,
//       avatar: "/images/avatars/default-avatar.jpg",
//     };

//     setChatMessages([...chatMessages, newChatMessage]);
//     setNewMessage("");

//     // In a real app, you would send this message to your signaling server
//     // or use Agora RTM to broadcast the message to all participants
//   };

//   const handleSendQuestion = (e) => {
//     e.preventDefault();
//     if (!newQuestion.trim()) return;

//     const newQuestionMessage = {
//       id: questionMessages.length + 1,
//       sender: "You",
//       role: "Student",
//       question: newQuestion,
//       time: new Date().toLocaleTimeString([], {
//         hour: "2-digit",
//         minute: "2-digit",
//       }),
//       upvotes: 0,
//       isAnswered: false,
//       isYou: true,
//       avatar: "/images/avatars/default-avatar.jpg",
//     };

//     setQuestionMessages([...questionMessages, newQuestionMessage]);
//     setNewQuestion("");

//     // In a real app, you would send this question to your signaling server
//   };

//   const toggleFullScreen = () => {
//     if (!document.fullscreenElement) {
//       videoContainerRef.current.requestFullscreen().catch((err) => {
//         console.error(
//           `Error attempting to enable full-screen mode: ${err.message}`
//         );
//       });
//       setIsFullScreen(true);
//     } else {
//       document.exitFullscreen();
//       setIsFullScreen(false);
//     }
//   };

//   const upvoteQuestion = (questionId) => {
//     setQuestionMessages(
//       questionMessages.map((q) =>
//         q.id === questionId ? { ...q, upvotes: q.upvotes + 1 } : q
//       )
//     );
//   };

//   // Sort questions by upvotes (highest first)
//   const sortedQuestions = [...questionMessages].sort(
//     (a, b) => b.upvotes - a.upvotes
//   );

//   // Resources list (study materials, slides, etc.)
//   const resources = [
//     {
//       id: 1,
//       name: "Lecture Slides: Constitutional Amendments",
//       type: "PDF",
//       size: "2.4 MB",
//       link: "#",
//     },
//     {
//       id: 2,
//       name: "Essential Articles of the Constitution",
//       type: "DOCX",
//       size: "1.8 MB",
//       link: "#",
//     },
//     {
//       id: 3,
//       name: "Supreme Court Case Studies (2021-23)",
//       type: "PDF",
//       size: "3.5 MB",
//       link: "#",
//     },
//     {
//       id: 4,
//       name: "Practice Questions: Fundamental Rights",
//       type: "PDF",
//       size: "1.2 MB",
//       link: "#",
//     },
//     {
//       id: 5,
//       name: "Pre-class Reading: Constitutional Framework",
//       type: "PDF",
//       size: "4.1 MB",
//       link: "#",
//     },
//   ];

//   // Poll data (for interactive learning)
//   const pollData = {
//     question:
//       "Which Article of the Indian Constitution abolishes untouchability?",
//     options: [
//       { id: 1, text: "Article 15", votes: 12 },
//       { id: 2, text: "Article 17", votes: 45 },
//       { id: 3, text: "Article 21", votes: 18 },
//       { id: 4, text: "Article 32", votes: 8 },
//     ],
//     totalVotes: 83,
//     yourVote: 2, // Option ID the user voted for (null if not voted)
//     correctAnswer: 2, // Option ID of the correct answer
//     isResultsVisible: true,
//   };

//   const calculatePercentage = (votes) => {
//     return Math.round((votes / pollData.totalVotes) * 100);
//   };

//   // Handle toggle raise hand
//   const toggleRaiseHand = () => {
//     setIsHandRaised(!isHandRaised);

//     // Add system message
//     const handMessage = {
//       id: chatMessages.length + 1,
//       sender: "System",
//       role: "System",
//       message: isHandRaised
//         ? "You have lowered your hand."
//         : "You have raised your hand. The instructor will see your request.",
//       time: new Date().toLocaleTimeString([], {
//         hour: "2-digit",
//         minute: "2-digit",
//       }),
//       isSystem: true,
//     };

//     setChatMessages((prev) => [...prev, handMessage]);

//     // In a real app, you would broadcast this status change to all participants
//     // using your signaling server or Agora RTM
//   };

//   // Toggle recording
//   const toggleRecording = () => {
//     if (isRecording) {
//       stopRecording();
//     } else {
//       startRecording();
//     }
//   };

//   // Handle class end (for moderators)
//   const endClass = async () => {
//     try {
//       // Make API call to end the class
//       const response = await fetch(`/api/classes/${classId}/end`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//       });

//       if (!response.ok) {
//         throw new Error("Failed to end class");
//       }

//       // Notify all participants
//       const endMessage = {
//         id: chatMessages.length + 1,
//         sender: "System",
//         role: "System",
//         message: "The instructor has ended the class. Thank you for attending.",
//         time: new Date().toLocaleTimeString([], {
//           hour: "2-digit",
//           minute: "2-digit",
//         }),
//         isSystem: true,
//         isImportant: true,
//       };

//       setChatMessages((prev) => [...prev, endMessage]);

//       // Leave the channel
//       await leaveChannel();

//       // Update class status
//       setClassData({
//         ...classData,
//         status: "ended",
//       });

//       // Redirect after a short delay
//       setTimeout(() => {
//         navigate("/classes");
//       }, 5000);
//     } catch (error) {
//       console.error("Error ending class:", error);
//     }
//   };

//   if (isLoading) {
//     return (
//       <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
//         <div className="text-center">
//           <div
//             className="animate-spin inline-block w-12 h-12 border-4 border-current border-t-transparent text-indigo-600 rounded-full"
//             role="status"
//             aria-label="loading"
//           >
//             <span className="sr-only">Loading...</span>
//           </div>
//           <p className="mt-4 text-lg text-gray-600">
//             Joining the live class...
//           </p>
//         </div>
//       </div>
//     );
//   }

//   if (!classData) {
//     return (
//       <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
//         <div className="text-center max-w-md px-4">
//           <svg
//             className="mx-auto h-16 w-16 text-gray-400"
//             fill="none"
//             viewBox="0 0 24 24"
//             stroke="currentColor"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth={2}
//               d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//             />
//           </svg>
//           <h2 className="mt-4 text-xl font-bold text-gray-700">
//             Class Not Found
//           </h2>
//           <p className="mt-2 text-gray-500">
//             We couldn't find the live class you're looking for. It may have
//             ended or been rescheduled.
//           </p>
//           <Link
//             to="/classes"
//             className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
//           >
//             Back to Classes
//           </Link>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen pt-16 bg-gray-100 mt-10">
//       {/* Main video and interaction area */}
//       <div className="flex flex-col lg:flex-row h-[calc(100vh-64px)]">
//         {/* Left side - Video and controls */}
//         <div className="lg:w-3/4 flex flex-col h-full">
//           {/* Class info bar */}
//           <div className="bg-indigo-900 text-white px-4 py-3 flex items-center justify-between">
//             <div className="flex items-center">
//               <div className="flex-shrink-0 h-10 w-10 rounded-full bg-indigo-700 flex items-center justify-center font-bold text-xl">
//                 {classData.title.charAt(0)}
//               </div>
//               <div className="ml-3">
//                 <h1 className="text-lg font-semibold">{classData.title}</h1>
//                 <div className="flex items-center text-xs text-indigo-200">
//                   <span className="flex items-center">
//                     <span className="mr-2">{classData.instructor}</span>
//                     {classData.status === "live" && (
//                       <>
//                         <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-red-500 text-white ml-2">
//                           <span className="animate-ping absolute h-2 w-2 rounded-full bg-red-400 opacity-75"></span>
//                           <span className="relative">LIVE</span>
//                         </span>
//                       </>
//                     )}
//                     {classData.status === "waiting" && (
//                       <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-500 text-white ml-2">
//                         WAITING FOR MODERATOR
//                       </span>
//                     )}
//                     {classData.status === "ended" && (
//                       <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-500 text-white ml-2">
//                         ENDED
//                       </span>
//                     )}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="flex items-center space-x-4">
//               {/* Recording button - visible only to moderators */}
//               {isUserModerator && (
//                 <button
//                   onClick={toggleRecording}
//                   className={`rounded-full p-2 ${
//                     isRecording
//                       ? "bg-red-500 text-white"
//                       : "bg-white/10 hover:bg-white/20"
//                   }`}
//                   title={isRecording ? "Stop Recording" : "Start Recording"}
//                 >
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                     />
//                   </svg>
//                 </button>
//               )}

//               {/* Resources button */}
//               <button
//                 className="text-white hover:text-indigo-100"
//                 onClick={() => setIsResourcesPanelOpen(!isResourcesPanelOpen)}
//                 title="Resources"
//               >
//                 <svg
//                   className="h-5 w-5"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
//                   />
//                 </svg>
//               </button>

//               {/* Notes button */}
//               <button
//                 className="text-white hover:text-indigo-100"
//                 onClick={() => setShowNotes(!showNotes)}
//                 title="Notes"
//               >
//                 <svg
//                   className="h-5 w-5"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
//                   />
//                 </svg>
//               </button>

//               {/* Network quality indicator */}
//               <div className="hidden md:flex items-center space-x-1 text-xs">
//                 <div className="flex h-4 space-x-0.5">
//                   {[1, 2, 3, 4, 5].map((level) => (
//                     <div
//                       key={level}
//                       className={`w-1 rounded-sm ${
//                         networkQuality <= level
//                           ? "bg-red-500"
//                           : level <= 2
//                           ? "bg-yellow-500"
//                           : "bg-green-500"
//                       }`}
//                       style={{
//                         height: `${level * 20}%`,
//                         alignSelf: "flex-end",
//                       }}
//                     ></div>
//                   ))}
//                 </div>
//                 <span className="ml-1">
//                   {networkQuality <= 2
//                     ? "Poor"
//                     : networkQuality <= 4
//                     ? "Good"
//                     : "Excellent"}
//                 </span>
//               </div>

//               {/* Class duration */}
//               <div className="hidden md:flex items-center space-x-2 text-xs">
//                 <svg
//                   className="h-4 w-4"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                   />
//                 </svg>
//                 <span>
//                   {classData.startTime} ({classData.duration})
//                 </span>
//               </div>

//               {/* Participant count */}
//               <div className="hidden md:flex items-center space-x-2 text-xs">
//                 <svg
//                   className="h-4 w-4"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
//                   />
//                 </svg>
//                 <span>{classData.participants} participants</span>
//               </div>
//             </div>
//           </div>

//           {/* Main video area */}
//           <div
//             className="flex-grow relative overflow-hidden bg-gray-900"
//             ref={videoContainerRef}
//           >
//             {waitingForModerator && !isUserModerator ? (
//               /* Waiting for moderator screen */
//               <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
//                 <div className="text-center px-4">
//                   <svg
//                     className="animate-pulse mx-auto h-16 w-16 text-indigo-400"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
//                     />
//                   </svg>
//                   <h2 className="mt-4 text-xl font-semibold">
//                     Waiting for moderator to start the class
//                   </h2>
//                   <p className="mt-2 text-gray-300 max-w-lg">
//                     The class will begin automatically when the instructor
//                     joins. You don't need to refresh the page.
//                   </p>
//                 </div>
//               </div>
//             ) : (
//               /* Active class view */
//               <div className="relative h-full">
//                 {/* Main video display - shows screenshare or active speaker */}
//                 <div className="w-full h-full bg-black flex items-center justify-center">
//                   {screenShareTrack ? (
//                     /* Show screen share if available */
//                     <div
//                       id="screenshare-container"
//                       className="w-full h-full"
//                     ></div>
//                   ) : /* Otherwise show active speaker or placeholder */
//                   remoteUsers.length > 0 ? (
//                     <div
//                       id={`player-${remoteUsers[0]?.uid || "main"}`}
//                       className="w-full h-full bg-gray-800"
//                     ></div>
//                   ) : (
//                     /* Placeholder when no video streams */
//                     <div className="text-center text-white">
//                       <svg
//                         className="mx-auto h-16 w-16 text-gray-500"
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path
//                           strokeLinecap="round"
//                           strokeLinejoin="round"
//                           strokeWidth={2}
//                           d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                         />
//                       </svg>
//                       <p className="mt-2">Video stream will appear here</p>
//                     </div>
//                   )}
//                 </div>

//                 {/* Video thumbnails - for active users */}
//                 <div className="absolute bottom-4 right-4 flex space-x-2">
//                   {/* Local video (if moderator) */}
//                   {isUserModerator && (
//                     <div className="w-32 h-24 rounded-lg overflow-hidden border-2 border-white bg-gray-800">
//                       <div
//                         ref={localPlayerRef}
//                         className="w-full h-full object-cover"
//                       ></div>
//                       <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-1">
//                         <div className="text-white text-xs font-medium">
//                           You (Instructor)
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                   {/* Remote user videos */}
//                   {remoteUsers
//                     .filter(
//                       (user) =>
//                         user.hasVideo && user.uid !== remoteUsers[0]?.uid
//                     )
//                     .slice(0, 3) // Limit to 3 thumbnails
//                     .map((user) => (
//                       <div
//                         key={user.uid}
//                         className="w-32 h-24 rounded-lg overflow-hidden border-2 border-white bg-gray-800"
//                       >
//                         <div
//                           id={`player-${user.uid}`}
//                           className="w-full h-full object-cover"
//                         ></div>
//                         <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-1">
//                           <div className="text-white text-xs font-medium truncate">
//                             {user.name} {user.isModerator && "(Instructor)"}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                 </div>

//                 {/* Recording indicator */}
//                 {isRecording && (
//                   <div className="absolute top-4 left-4 bg-red-600 text-white text-xs font-medium px-2 py-1 rounded-full flex items-center">
//                     <span className="animate-pulse mr-1">●</span>
//                     REC
//                   </div>
//                 )}

//                 {/* Poll overlay (when active) */}
//                 {/* <div className="absolute top-4 right-4 w-72 bg-white rounded-lg shadow-lg overflow-hidden">
//                   <div className="bg-indigo-600 text-white p-3">
//                     <h3 className="font-medium">Poll Question</h3>
//                   </div>
//                   <div className="p-4">
//                     <p className="text-sm font-medium text-gray-700 mb-3">
//                       {pollData.question}
//                     </p>
//                     <div className="space-y-2">
//                       {pollData.options.map((option) => (
//                         <div key={option.id} className="relative">
//                           <div
//                             className={`text-sm p-2 rounded ${
//                               pollData.correctAnswer === option.id
//                                 ? "bg-green-100 border border-green-300"
//                                 : pollData.yourVote === option.id
//                                 ? "bg-blue-100 border border-blue-300"
//                                 : "bg-gray-100"
//                             }`}
//                           >
//                             <div className="flex justify-between">
//                               <span>{option.text}</span>
//                               {pollData.isResultsVisible && (
//                                 <span className="font-medium">
//                                   {calculatePercentage(option.votes)}%
//                                 </span>
//                               )}
//                             </div>
//                             {pollData.isResultsVisible && (
//                               <div className="mt-1 h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
//                                 <div
//                                   className={`h-full ${
//                                     pollData.correctAnswer === option.id
//                                       ? "bg-green-500"
//                                       : "bg-blue-500"
//                                   }`}
//                                   style={{
//                                     width: `${calculatePercentage(
//                                       option.votes
//                                     )}%`,
//                                   }}
//                                 ></div>
//                               </div>
//                             )}
//                           </div>
//                           {pollData.isResultsVisible &&
//                             pollData.correctAnswer === option.id && (
//                               <svg
//                                 className="absolute right-2 top-2 h-5 w-5 text-green-600"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
//                                 />
//                               </svg>
//                             )}
//                         </div>
//                       ))}
//                     </div>
//                     {!pollData.yourVote && !pollData.isResultsVisible && (
//                       <button className="mt-3 w-full bg-indigo-600 text-white py-2 px-4 rounded text-sm font-medium hover:bg-indigo-700">
//                         Submit Answer
//                       </button>
//                     )}
//                     <div className="mt-3 text-xs text-gray-500 text-center">
//                       {pollData.isResultsVisible ? (
//                         <span>{pollData.totalVotes} votes • Poll closed</span>
//                       ) : (
//                         <span>Poll active • 30 seconds remaining</span>
//                       )}
//                     </div>
//                   </div>
//                 </div> */}

//                 {/* Notes overlay */}
//                 {showNotes && (
//                   <div className="absolute inset-0 bg-black/50 flex items-center justify-center p-6 z-10">
//                     <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-full overflow-auto">
//                       <div className="flex justify-between items-center p-4 border-b">
//                         <h3 className="font-semibold text-lg">Class Notes</h3>
//                         <button
//                           onClick={() => setShowNotes(false)}
//                           className="text-gray-500 hover:text-gray-700"
//                         >
//                           <svg
//                             className="h-5 w-5"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M6 18L18 6M6 6l12 12"
//                             />
//                           </svg>
//                         </button>
//                       </div>
//                       <div className="p-4">
//                         <textarea
//                           className="w-full h-64 p-3 border border-gray-300 rounded-lg focus:ring-indigo-500 focus:border-indigo-500"
//                           placeholder="Type your class notes here..."
//                         ></textarea>
//                         <div className="mt-4 flex justify-between">
//                           <button className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800">
//                             <svg
//                               className="h-4 w-4 mr-1"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4"
//                               />
//                             </svg>
//                             Save
//                           </button>
//                           <button className="inline-flex items-center text-sm text-gray-600 hover:text-gray-800">
//                             <svg
//                               className="h-4 w-4 mr-1"
//                               fill="none"
//                               viewBox="0 0 24 24"
//                               stroke="currentColor"
//                             >
//                               <path
//                                 strokeLinecap="round"
//                                 strokeLinejoin="round"
//                                 strokeWidth={2}
//                                 d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
//                               />
//                             </svg>
//                             Download
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}

//                 {/* Resources panel overlay */}
//                 {isResourcesPanelOpen && (
//                   <div className="absolute inset-0 bg-black/50 flex items-center justify-center p-6 z-10">
//                     <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-full overflow-auto">
//                       <div className="flex justify-between items-center p-4 border-b">
//                         <h3 className="font-semibold text-lg">
//                           Class Resources
//                         </h3>
//                         <button
//                           onClick={() => setIsResourcesPanelOpen(false)}
//                           className="text-gray-500 hover:text-gray-700"
//                         >
//                           <svg
//                             className="h-5 w-5"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M6 18L18 6M6 6l12 12"
//                             />
//                           </svg>
//                         </button>
//                       </div>
//                       <div className="p-4">
//                         <div className="space-y-3">
//                           {resources.map((resource) => (
//                             <div
//                               key={resource.id}
//                               className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
//                             >
//                               <div className="flex items-center">
//                                 <div className="flex-shrink-0">
//                                   {resource.type === "PDF" ? (
//                                     <div className="w-10 h-10 bg-red-100 text-red-600 rounded flex items-center justify-center">
//                                       <svg
//                                         className="h-6 w-6"
//                                         fill="none"
//                                         viewBox="0 0 24 24"
//                                         stroke="currentColor"
//                                       >
//                                         <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
//                                         />
//                                       </svg>
//                                     </div>
//                                   ) : resource.type === "DOCX" ? (
//                                     <div className="w-10 h-10 bg-blue-100 text-blue-600 rounded flex items-center justify-center">
//                                       <svg
//                                         className="h-6 w-6"
//                                         fill="none"
//                                         viewBox="0 0 24 24"
//                                         stroke="currentColor"
//                                       >
//                                         <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                                         />
//                                       </svg>
//                                     </div>
//                                   ) : (
//                                     <div className="w-10 h-10 bg-gray-100 text-gray-600 rounded flex items-center justify-center">
//                                       <svg
//                                         className="h-6 w-6"
//                                         fill="none"
//                                         viewBox="0 0 24 24"
//                                         stroke="currentColor"
//                                       >
//                                         <path
//                                           strokeLinecap="round"
//                                           strokeLinejoin="round"
//                                           strokeWidth={2}
//                                           d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
//                                         />
//                                       </svg>
//                                     </div>
//                                   )}
//                                 </div>
//                                 <div className="ml-3">
//                                   <h4 className="text-sm font-medium text-gray-900">
//                                     {resource.name}
//                                   </h4>
//                                   <p className="text-xs text-gray-500">
//                                     {resource.type} • {resource.size}
//                                   </p>
//                                 </div>
//                               </div>
//                               <a
//                                 href={resource.link}
//                                 className="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-800"
//                                 download
//                               >
//                                 <svg
//                                   className="h-5 w-5"
//                                   fill="none"
//                                   viewBox="0 0 24 24"
//                                   stroke="currentColor"
//                                 >
//                                   <path
//                                     strokeLinecap="round"
//                                     strokeLinejoin="round"
//                                     strokeWidth={2}
//                                     d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
//                                   />
//                                 </svg>
//                               </a>
//                             </div>
//                           ))}
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>

//           {/* Video controls bar */}
//           <div className="bg-indigo-800 p-3 text-white flex items-center justify-between">
//             <div className="flex items-center space-x-4">
//               {/* Microphone control - only active for moderators */}
//               <button
//                 onClick={toggleMic}
//                 className={`p-2 rounded-full ${
//                   !isUserModerator
//                     ? "bg-gray-700 cursor-not-allowed opacity-50"
//                     : isMicMuted
//                     ? "bg-red-500"
//                     : "bg-indigo-600 hover:bg-indigo-700"
//                 }`}
//                 title={isMicMuted ? "Unmute Microphone" : "Mute Microphone"}
//                 disabled={!isUserModerator}
//               >
//                 {isMicMuted ? (
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
//                     />
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M3 3l18 18"
//                     />
//                   </svg>
//                 ) : (
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"
//                     />
//                   </svg>
//                 )}
//               </button>

//               {/* Camera control - only active for moderators */}
//               <button
//                 onClick={toggleCamera}
//                 className={`p-2 rounded-full ${
//                   !isUserModerator
//                     ? "bg-gray-700 cursor-not-allowed opacity-50"
//                     : isCameraOff
//                     ? "bg-red-500"
//                     : "bg-indigo-600 hover:bg-indigo-700"
//                 }`}
//                 title={isCameraOff ? "Turn Camera On" : "Turn Camera Off"}
//                 disabled={!isUserModerator}
//               >
//                 {isCameraOff ? (
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                     />
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M3 3l18 18"
//                     />
//                   </svg>
//                 ) : (
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
//                     />
//                   </svg>
//                 )}
//               </button>

//               {/* Screen sharing - only active for moderators */}
//               <button
//                 onClick={toggleScreenSharing}
//                 className={`p-2 rounded-full ${
//                   !isUserModerator
//                     ? "bg-gray-700 cursor-not-allowed opacity-50"
//                     : isScreenSharing
//                     ? "bg-green-500"
//                     : "bg-indigo-600 hover:bg-indigo-700"
//                 }`}
//                 title={isScreenSharing ? "Stop Sharing" : "Share Screen"}
//                 disabled={!isUserModerator}
//               >
//                 <svg
//                   className="h-5 w-5"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
//                   />
//                 </svg>
//               </button>

//               {/* Raise hand - for students */}
//               <button
//                 onClick={toggleRaiseHand}
//                 className={`p-2 rounded-full ${
//                   isHandRaised
//                     ? "bg-yellow-500"
//                     : "bg-indigo-600 hover:bg-indigo-700"
//                 }`}
//                 title={isHandRaised ? "Lower Hand" : "Raise Hand"}
//               >
//                 <svg
//                   className="h-5 w-5"
//                   fill="none"
//                   viewBox="0 0 24 24"
//                   stroke="currentColor"
//                 >
//                   <path
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                     strokeWidth={2}
//                     d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
//                   />
//                 </svg>
//               </button>
//             </div>

//             <div className="flex items-center space-x-4">
//               {/* Fullscreen toggle */}
//               <button
//                 onClick={toggleFullScreen}
//                 className="p-2 rounded-full bg-indigo-600 hover:bg-indigo-700"
//                 title="Toggle Fullscreen"
//               >
//                 {isFullScreen ? (
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M9 9V4.5M9 9H4.5M15 9H19.5M15 9V4.5M15 15v4.5M15 15H4.5M15 15h4.5M9 15v4.5"
//                     />
//                   </svg>
//                 ) : (
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5v-4m0 4h-4m4 0l-5-5"
//                     />
//                   </svg>
//                 )}
//               </button>

//               {/* End class button - for moderators only */}
//               {isUserModerator ? (
//                 <button
//                   onClick={endClass}
//                   className="p-2 rounded-full bg-red-600 hover:bg-red-700"
//                   title="End Class"
//                 >
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M6 18L18 6M6 6l12 12"
//                     />
//                   </svg>
//                 </button>
//               ) : (
//                 /* Leave class button - for students */
//                 <Link
//                   to="/classes"
//                   className="p-2 rounded-full bg-red-600 hover:bg-red-700"
//                   title="Leave Class"
//                 >
//                   <svg
//                     className="h-5 w-5"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                     stroke="currentColor"
//                   >
//                     <path
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                       strokeWidth={2}
//                       d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
//                     />
//                   </svg>
//                 </Link>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Right side - Chat, Q&A, participants */}
//         <div className="lg:w-1/4 border-l border-gray-200 flex flex-col h-full bg-white">
//           {/* Tabs for chat, Q&A, participants */}
//           <div className="bg-gray-100 p-1">
//             <div className="flex border-b border-gray-200">
//               <button
//                 className={`py-2 px-4 text-center text-sm font-medium flex-1 ${
//                   activeTab === "video"
//                     ? "text-indigo-600 border-b-2 border-indigo-600"
//                     : "text-gray-500 hover:text-gray-700"
//                 }`}
//                 onClick={() => setActiveTab("video")}
//               >
//                 Chat
//               </button>
//               <button
//                 className={`py-2 px-4 text-center text-sm font-medium flex-1 ${
//                   activeTab === "qa"
//                     ? "text-indigo-600 border-b-2 border-indigo-600"
//                     : "text-gray-500 hover:text-gray-700"
//                 }`}
//                 onClick={() => setActiveTab("qa")}
//               >
//                 Q&A
//               </button>
//               <button
//                 className={`py-2 px-4 text-center text-sm font-medium flex-1 ${
//                   activeTab === "participants"
//                     ? "text-indigo-600 border-b-2 border-indigo-600"
//                     : "text-gray-500 hover:text-gray-700"
//                 }`}
//                 onClick={() => setActiveTab("participants")}
//               >
//                 People
//               </button>
//             </div>
//           </div>

//           {/* Chat tab */}
//           {activeTab === "video" && (
//             <div className="flex flex-col h-full">
//               <div
//                 className="flex-grow overflow-y-auto p-3 space-y-3"
//                 ref={chatContainerRef}
//               >
//                 {chatMessages.map((message) => (
//                   <div
//                     key={message.id}
//                     className={`flex ${message.isYou ? "justify-end" : ""}`}
//                   >
//                     <div
//                       className={`max-w-3/4 ${message.isYou ? "order-2" : ""}`}
//                     >
//                       <div className="flex items-end">
//                         {!message.isYou && !message.isSystem && (
//                           <div className="flex-shrink-0 mr-2">
//                             <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden">
//                               <img
//                                 src={
//                                   message.avatar ||
//                                   "/images/avatars/default-avatar.jpg"
//                                 }
//                                 alt={message.sender}
//                                 className="h-full w-full object-cover"
//                               />
//                             </div>
//                           </div>
//                         )}
//                         <div className={`${message.isSystem ? "w-full" : ""}`}>
//                           <div
//                             className={`rounded-lg px-3 py-2 ${
//                               message.isSystem
//                                 ? message.isError
//                                   ? "bg-red-100 text-red-800 border border-red-300"
//                                   : message.isWarning
//                                   ? "bg-yellow-100 text-yellow-800 border border-yellow-300"
//                                   : message.isSuccess
//                                   ? "bg-green-100 text-green-800 border border-green-300"
//                                   : "bg-gray-100 text-gray-800 border border-gray-300"
//                                 : message.role === "Instructor"
//                                 ? "bg-indigo-100 text-indigo-800"
//                                 : message.role === "Teaching Assistant"
//                                 ? "bg-purple-100 text-purple-800"
//                                 : message.isYou
//                                 ? "bg-blue-100 text-blue-800"
//                                 : "bg-gray-100 text-gray-800"
//                             }`}
//                           >
//                             {!message.isSystem && (
//                               <div className="text-xs font-medium flex justify-between mb-1">
//                                 <span>
//                                   {message.sender}
//                                   {message.role !== "Student" &&
//                                     message.role !== "System" && (
//                                       <span className="ml-1 text-xs opacity-75">
//                                         ({message.role})
//                                       </span>
//                                     )}
//                                 </span>
//                                 <span className="text-xs opacity-75">
//                                   {message.time}
//                                 </span>
//                               </div>
//                             )}
//                             <p
//                               className={`text-sm whitespace-pre-wrap break-words ${
//                                 message.isSystem ? "text-center" : ""
//                               }`}
//                             >
//                               {message.isSystem && (
//                                 <span className="font-medium block">
//                                   {message.time} - System Message
//                                 </span>
//                               )}
//                               {message.message}
//                             </p>
//                           </div>
//                         </div>
//                         {message.isYou && !message.isSystem && (
//                           <div className="flex-shrink-0 ml-2">
//                             <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden">
//                               <img
//                                 src={
//                                   message.avatar ||
//                                   "/images/avatars/default-avatar.jpg"
//                                 }
//                                 alt={message.sender}
//                                 className="h-full w-full object-cover"
//                               />
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//                 {chatMessages.length === 0 && (
//                   <div className="flex flex-col items-center justify-center h-full text-gray-500">
//                     <svg
//                       className="h-12 w-12 mb-2"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={1}
//                         d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
//                       />
//                     </svg>
//                     <p className="text-sm">No messages yet</p>
//                   </div>
//                 )}
//               </div>
//               <div className="p-3 border-t border-gray-200">
//                 <form onSubmit={handleSendMessage} className="flex">
//                   <input
//                     type="text"
//                     placeholder="Type a message..."
//                     value={newMessage}
//                     onChange={(e) => setNewMessage(e.target.value)}
//                     className="flex-grow border border-gray-300 rounded-l-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
//                     disabled={waitingForModerator && !isUserModerator}
//                   />
//                   <button
//                     type="submit"
//                     className={`px-3 py-2 rounded-r-md ${
//                       waitingForModerator && !isUserModerator
//                         ? "bg-gray-400 cursor-not-allowed"
//                         : "bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
//                     }`}
//                     disabled={waitingForModerator && !isUserModerator}
//                   >
//                     <svg
//                       className="h-5 w-5"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={2}
//                         d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
//                       />
//                     </svg>
//                   </button>
//                 </form>
//               </div>
//             </div>
//           )}

//           {/* Q&A tab */}
//           {activeTab === "qa" && (
//             <div className="flex flex-col h-full">
//               <div
//                 className="flex-grow overflow-y-auto p-3 space-y-3"
//                 ref={questionContainerRef}
//               >
//                 {sortedQuestions.map((question) => (
//                   <div
//                     key={question.id}
//                     className="bg-white rounded-lg border border-gray-200 shadow-sm"
//                   >
//                     <div className="p-3">
//                       <div className="flex items-start justify-between mb-2">
//                         <div className="flex items-center">
//                           <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden mr-2">
//                             <img
//                               src={
//                                 question.avatar ||
//                                 "/images/avatars/default-avatar.jpg"
//                               }
//                               alt={question.sender}
//                               className="h-full w-full object-cover"
//                             />
//                           </div>
//                           <div>
//                             <div className="text-sm font-medium">
//                               {question.sender}
//                             </div>
//                             <div className="text-xs text-gray-500">
//                               {question.time}
//                             </div>
//                           </div>
//                         </div>
//                         <button
//                           onClick={() => upvoteQuestion(question.id)}
//                           className={`px-2 py-1 rounded-full flex items-center ${
//                             question.isYou
//                               ? "bg-gray-200 cursor-not-allowed"
//                               : "bg-gray-100 hover:bg-gray-200"
//                           }`}
//                           disabled={question.isYou || waitingForModerator}
//                         >
//                           <svg
//                             className="h-4 w-4 text-gray-600 mr-1"
//                             fill="none"
//                             viewBox="0 0 24 24"
//                             stroke="currentColor"
//                           >
//                             <path
//                               strokeLinecap="round"
//                               strokeLinejoin="round"
//                               strokeWidth={2}
//                               d="M5 15l7-7 7 7"
//                             />
//                           </svg>
//                           <span className="text-xs font-medium">
//                             {question.upvotes}
//                           </span>
//                         </button>
//                       </div>
//                       <p className="text-sm mb-2">{question.question}</p>
//                       {question.isAnswered && (
//                         <div className="bg-indigo-50 p-2 rounded-md mt-2 border-l-2 border-indigo-500">
//                           <div className="text-xs font-medium text-indigo-800 mb-1">
//                             Answer from instructor:
//                           </div>
//                           <p className="text-sm text-gray-700">
//                             {question.answer}
//                           </p>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//                 {questionMessages.length === 0 && (
//                   <div className="flex flex-col items-center justify-center h-full text-gray-500">
//                     <svg
//                       className="h-12 w-12 mb-2"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                       stroke="currentColor"
//                     >
//                       <path
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                         strokeWidth={1}
//                         d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
//                       />
//                     </svg>
//                     <p className="text-sm">No questions yet</p>
//                   </div>
//                 )}
//               </div>
//               <div className="p-3 border-t border-gray-200">
//                 <form onSubmit={handleSendQuestion} className="flex flex-col">
//                   <textarea
//                     placeholder={
//                       waitingForModerator && !isUserModerator
//                         ? "Questions can be asked once the moderator starts the class..."
//                         : "Ask a question..."
//                     }
//                     value={newQuestion}
//                     onChange={(e) => setNewQuestion(e.target.value)}
//                     className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 min-h-[80px]"
//                     disabled={waitingForModerator && !isUserModerator}
//                   ></textarea>
//                   <button
//                     type="submit"
//                     className={`mt-2 py-2 px-4 rounded-md text-sm ${
//                       waitingForModerator && !isUserModerator
//                         ? "bg-gray-400 text-white cursor-not-allowed"
//                         : "bg-indigo-600 text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
//                     }`}
//                     disabled={waitingForModerator && !isUserModerator}
//                   >
//                     Submit Question
//                   </button>
//                 </form>
//               </div>
//             </div>
//           )}

//           {/* Participants tab */}
//           {activeTab === "participants" && (
//             <div className="h-full overflow-y-auto p-3">
//               <div className="mb-4">
//                 <h3 className="text-sm font-medium text-gray-700 mb-2">
//                   Hosts & Presenters
//                 </h3>
//                 <div className="space-y-2">
//                   {participants
//                     .filter(
//                       (p) =>
//                         p.role === "Instructor" ||
//                         p.role === "Teaching Assistant"
//                     )
//                     .map((participant) => {
//                       // Find matching remote user to check connection status
//                       const remoteUser = remoteUsers.find(
//                         (u) => u.uid === participant.uid
//                       );
//                       const isConnected = remoteUser !== undefined;

//                       return (
//                         <div
//                           key={participant.id}
//                           className="flex items-center justify-between"
//                         >
//                           <div className="flex items-center">
//                             <div className="relative h-8 w-8 rounded-full bg-gray-200 overflow-hidden mr-2">
//                               <img
//                                 src={
//                                   participant.avatar ||
//                                   "/images/avatars/default-avatar.jpg"
//                                 }
//                                 alt={participant.name}
//                                 className="h-full w-full object-cover"
//                               />
//                               <div
//                                 className={`absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white ${
//                                   isConnected ? "bg-green-500" : "bg-gray-500"
//                                 }`}
//                               ></div>
//                             </div>
//                             <div>
//                               <div className="text-sm font-medium flex items-center">
//                                 {participant.name}
//                                 {participant.isYou && (
//                                   <span className="ml-1 text-xs">(You)</span>
//                                 )}
//                               </div>
//                               <div className="text-xs text-gray-500">
//                                 {participant.role}
//                               </div>
//                             </div>
//                           </div>
//                           {participant.isHost && (
//                             <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
//                               Host
//                             </span>
//                           )}
//                         </div>
//                       );
//                     })}
//                 </div>
//               </div>

//               <div>
//                 <h3 className="text-sm font-medium text-gray-700 mb-2">
//                   Students (
//                   {participants.filter((p) => p.role === "Student").length})
//                 </h3>
//                 <div className="space-y-2">
//                   {participants
//                     .filter((p) => p.role === "Student")
//                     .map((participant) => {
//                       // Find matching remote user to check connection status
//                       const remoteUser = remoteUsers.find(
//                         (u) => u.uid === participant.uid
//                       );
//                       const isConnected = remoteUser !== undefined;

//                       return (
//                         <div
//                           key={participant.id}
//                           className="flex items-center justify-between"
//                         >
//                           <div className="flex items-center">
//                             <div className="relative h-8 w-8 rounded-full bg-gray-200 overflow-hidden mr-2">
//                               <img
//                                 src={
//                                   participant.avatar ||
//                                   "/images/avatars/default-avatar.jpg"
//                                 }
//                                 alt={participant.name}
//                                 className="h-full w-full object-cover"
//                               />
//                               <div
//                                 className={`absolute bottom-0 right-0 h-3 w-3 rounded-full border-2 border-white ${
//                                   isConnected ? "bg-green-500" : "bg-gray-500"
//                                 }`}
//                               ></div>
//                             </div>
//                             <div className="text-sm">
//                               {participant.name}
//                               {participant.isYou && (
//                                 <span className="ml-1 text-xs">(You)</span>
//                               )}
//                             </div>
//                           </div>
//                           {(participant.isHandRaised ||
//                             (isHandRaised && participant.isYou)) && (
//                             <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
//                               <svg
//                                 className="h-3 w-3 mr-1"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                               >
//                                 <path
//                                   strokeLinecap="round"
//                                   strokeLinejoin="round"
//                                   strokeWidth={2}
//                                   d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11"
//                                 />
//                               </svg>
//                               Hand Raised
//                             </span>
//                           )}
//                         </div>
//                       );
//                     })}
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LiveClassPage;
// pages/JoinClassPage.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { CONSTANTS } from "../constants/Constants";

/**
 * JoinClassPage - The component students use to join a BigBlueButton class session
 * 
 * This component:
 * 1. Displays class info
 * 2. Allows students to enter their name
 * 3. Handles joining the BigBlueButton session
 */
const LiveClassPage = () => {
  const { classId } = useParams();
  const navigate = useNavigate();
  
  // States
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [classData, setClassData] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [isJoining, setIsJoining] = useState(false);
  const [meetingStatus, setMeetingStatus] = useState(null);
  
  // Check if the user is already logged in
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  
  // Fetch class data and meeting status
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        
        // Check authentication status
        const token = localStorage.getItem("token");
        const userName = localStorage.getItem("userName");
        
        if (token) {
          setIsLoggedIn(true);
          setStudentName(userName || "");
          
          try {
            const userResponse = await axios.get(`${CONSTANTS.APIURL}/api/users/me`, {
              headers: { Authorization: `Bearer ${token}` }
            });
            
            if (userResponse.data) {
              setCurrentUser(userResponse.data);
              setStudentName(userResponse.data.name || userName || "");
            }
          } catch (authError) {
            console.error("Error fetching user data:", authError);
          }
        }
        
        // Fetch class data
        const classResponse = await axios.get(`${CONSTANTS.APIURL}/api/classes/${classId}/public`);
        
        if (classResponse.data) {
          setClassData(classResponse.data);
        } else {
          setError("Class not found");
        }
        
        // Check meeting status
        const statusResponse = await axios.get(`${CONSTANTS.APIURL}/api/bigbluebutton/meetings/${classId}`);
        
        if (statusResponse.data) {
          setMeetingStatus(statusResponse.data);
        }
        
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load class information. Please try again.");
        setIsLoading(false);
      }
    };
    
    fetchData();
    
    // Set up polling to check meeting status every 15 seconds
    const statusInterval = setInterval(async () => {
      try {
        const statusResponse = await axios.get(`${CONSTANTS.APIURL}/api/bigbluebutton/meetings/${classId}`);
        
        if (statusResponse.data) {
          setMeetingStatus(statusResponse.data);
        }
      } catch (error) {
        console.error("Error checking meeting status:", error);
      }
    }, 15000);
    
    return () => clearInterval(statusInterval);
  }, [classId]);
  
  // Handle join button click
  const handleJoin = async (e) => {
    e.preventDefault();
    
    if (!studentName.trim()) {
      setError("Please enter your name to join the class");
      return;
    }
    
    try {
      setIsJoining(true);
      
      // Request to join meeting
      const joinResponse = await axios.post(
        `${CONSTANTS.APIURL}/api/bigbluebutton/join`,
        {
          meetingID: classId,
          fullName: studentName.trim(),
          role: "VIEWER",
          userID: currentUser?._id || null,
          redirect: false
        },
        isLoggedIn ? {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        } : undefined
      );
      
      if (joinResponse.data && joinResponse.data.joinURL) {
        // Track participation in the database if logged in
        if (isLoggedIn) {
          try {
            await axios.post(
              `${CONSTANTS.APIURL}/api/classes/${classId}/participants`,
              {
                userID: currentUser?._id,
                name: studentName.trim(),
                joinTime: new Date(),
                isLoggedIn: true
              },
              {
                headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
              }
            );
          } catch (trackError) {
            console.error("Error tracking participation:", trackError);
            // Continue with join even if tracking fails
          }
        }
        
        // Redirect to BBB meeting
        window.location.href = joinResponse.data.joinURL;
      } else {
        throw new Error("Invalid join URL");
      }
    } catch (error) {
      console.error("Error joining class:", error);
      setError(error.response?.data?.message || "Failed to join the class. Please try again.");
      setIsJoining(false);
    }
  };
  
  // If class not found
  if (!isLoading && !classData) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md px-4">
          <svg
            className="mx-auto h-16 w-16 text-gray-400"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <h2 className="mt-4 text-xl font-bold text-gray-700">
            Class Not Found
          </h2>
          <p className="mt-2 text-gray-500">
            We couldn't find the live class you're looking for. It may have
            ended or been rescheduled.
          </p>
          <Link
            to="/classes"
            className="mt-6 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
          >
            Back to Classes
          </Link>
        </div>
      </div>
    );
  }
  
  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div
            className="animate-spin inline-block w-12 h-12 border-4 border-current border-t-transparent text-indigo-600 rounded-full"
            role="status"
            aria-label="loading"
          >
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-4 text-lg text-gray-600">
            Loading class information...
          </p>
        </div>
      </div>
    );
  }
  
  return (
    <div className="min-h-screen pt-16 bg-gray-100">
      <div className="max-w-3xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg overflow-hidden">
          {/* Class header */}
          <div className="bg-indigo-700 text-white px-6 py-8">
            <div className="flex items-center justify-between">
              <h1 className="text-2xl font-bold">{classData.title}</h1>
              <span 
                className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                  meetingStatus?.running 
                    ? "bg-green-500 text-white"
                    : meetingStatus?.exists 
                      ? "bg-yellow-500 text-white" 
                      : "bg-gray-500 text-white"
                }`}
              >
                {meetingStatus?.running 
                  ? "In Progress" 
                  : meetingStatus?.exists 
                    ? "Ready to Join" 
                    : "Not Started"}
              </span>
            </div>
            <p className="mt-2 text-indigo-100">Instructor: {classData.instructor}</p>
          </div>
          
          {/* Class information */}
          <div className="px-6 py-6 border-b border-gray-200">
            <div className="flex items-center justify-between text-sm text-gray-500 mb-6">
              <div className="flex items-center">
                <svg className="h-5 w-5 mr-1 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span>
                  {classData.startTime} ({classData.duration})
                </span>
              </div>
              
              <div className="flex items-center">
                <svg className="h-5 w-5 mr-1 text-indigo-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
                <span>
                  {meetingStatus?.running 
                    ? `${meetingStatus.participantCount || 0} participants` 
                    : "0 participants"}
                </span>
              </div>
            </div>
            
            <div className="prose max-w-none">
              <h3 className="text-lg font-medium text-gray-900">About this class</h3>
              <p className="text-gray-600">{classData.description}</p>
            </div>
          </div>
          
          {/* Join form */}
          <div className="px-6 py-6">
            <h3 className="text-lg font-medium text-gray-900 mb-4">Join this class</h3>
            
            {error && (
              <div className="mb-4 bg-red-50 border-l-4 border-red-400 p-4">
                <div className="flex">
                  <div className="flex-shrink-0">
                    <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
                    </svg>
                  </div>
                  <div className="ml-3">
                    <p className="text-sm text-red-700">{error}</p>
                  </div>
                  <div className="ml-auto pl-3">
                    <div className="-mx-1.5 -my-1.5">
                      <button
                        onClick={() => setError(null)}
                        className="inline-flex bg-red-50 rounded-md p-1.5 text-red-500 hover:bg-red-100"
                      >
                        <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            
            {meetingStatus?.running || meetingStatus?.exists ? (
              <form onSubmit={handleJoin} className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Your Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    id="name"
                    value={studentName}
                    onChange={(e) => setStudentName(e.target.value)}
                    placeholder="Enter your full name"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    required
                    disabled={isJoining}
                  />
                  <p className="mt-1 text-xs text-gray-500">This is how you'll appear to others in the class</p>
                </div>
                
                <div className="flex items-center">
                  <input
                    id="agree-terms"
                    name="agree-terms"
                    type="checkbox"
                    className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                    required
                  />
                  <label htmlFor="agree-terms" className="ml-2 block text-sm text-gray-900">
                    I agree to follow classroom etiquette and will not disrupt the session
                  </label>
                </div>
                
                <div>
                  <button
                    type="submit"
                    className={`w-full inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${isJoining ? 'opacity-75 cursor-not-allowed' : ''}`}
                    disabled={isJoining}
                  >
                    {isJoining ? (
                      <>
                        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Joining...
                      </>
                    ) : (
                      <>
                        <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                        </svg>
                        Join Class
                      </>
                    )}
                  </button>
                </div>
              </form>
            ) : (
              <div className="text-center py-6">
                <svg className="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <h3 className="mt-2 text-sm font-medium text-gray-900">Class not started yet</h3>
                <p className="mt-1 text-sm text-gray-500">
                  The instructor hasn't started this class yet. Please check back later.
                </p>
                <div className="mt-6">
                  <button
                    onClick={() => window.location.reload()}
                    className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    <svg className="-ml-1 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    Refresh
                  </button>
                </div>
              </div>
            )}
          </div>
          
          {/* Tips/guidelines */}
          {(meetingStatus?.running || meetingStatus?.exists) && (
            <div className="bg-gray-50 px-6 py-6 border-t border-gray-200">
              <h3 className="text-sm font-medium text-gray-900 mb-2">Tips for a great class experience:</h3>
              <ul className="text-sm text-gray-600 space-y-1 pl-5 list-disc">
                <li>Use headphones to avoid audio feedback</li>
                <li>Mute your microphone when not speaking</li>
                <li>Use the "Raise Hand" feature before speaking</li>
                <li>Test your camera and microphone before joining</li>
                <li>Make sure you're in a quiet environment</li>
              </ul>
            </div>
          )}
        </div>
        
        <div className="mt-6 text-center">
          <Link
            to="/classes"
            className="inline-flex items-center text-sm text-indigo-600 hover:text-indigo-500"
          >
            <svg className="mr-1 h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Back to Classes
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LiveClassPage;